webpackJsonp(["main"],{

/***/ "./src/images/friends/reset.svg":
/*!**************************************!*\
  !*** ./src/images/friends/reset.svg ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "reset.3b4c5513.svg";

/***/ }),

/***/ "./src/images/friends/smuggler.svg":
/*!*****************************************!*\
  !*** ./src/images/friends/smuggler.svg ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "smuggler.eb00f64d.svg";

/***/ }),

/***/ "./src/scripts/components/AboutHeader.js":
/*!***********************************************!*\
  !*** ./src/scripts/components/AboutHeader.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _Logo = _interopRequireDefault(__webpack_require__(/*! ../elements/Logo */ "./src/scripts/elements/Logo.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AboutHeader =
/*#__PURE__*/
function (_Component) {
  _inherits(AboutHeader, _Component);

  function AboutHeader() {
    _classCallCheck(this, AboutHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(AboutHeader).apply(this, arguments));
  }

  _createClass(AboutHeader, [{
    key: "render",
    value: function render() {
      var headerImage = this.props.headerImage;
      return _react.default.createElement("div", {
        className: "about-header"
      }, _react.default.createElement("div", {
        className: "about-header__inner"
      }, _react.default.createElement("div", {
        className: "about-header__image-container"
      }, headerImage && _react.default.createElement("div", {
        className: "about-header__image",
        style: {
          paddingTop: "".concat(headerImage.height / headerImage.width * 100, "%")
        }
      }, _react.default.createElement("picture", null, _react.default.createElement("source", {
        media: "(max-width: 900px)",
        srcSet: headerImage.mobile
      }), _react.default.createElement("img", {
        src: headerImage.desktop,
        alt: "Exit Films"
      })))), _react.default.createElement("div", {
        className: "about-header__logo"
      }, _react.default.createElement(_Logo.default, null))));
    }
  }]);

  return AboutHeader;
}(_react.Component);

_defineProperty(AboutHeader, "propTypes", {
  headerImage: _propTypes.default.shape({
    thumb: _propTypes.default.string,
    mobile: _propTypes.default.string,
    desktop: _propTypes.default.string
  })
});

var _default = AboutHeader;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/App.js":
/*!***************************************!*\
  !*** ./src/scripts/components/App.js ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _reactHotLoader = __webpack_require__(/*! react-hot-loader */ "./node_modules/react-hot-loader/index.js");

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _About = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/About */ "./src/scripts/components/pages/About.js"));

var _Home = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/Home */ "./src/scripts/components/pages/Home.js"));

var _LineProducers = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/LineProducers */ "./src/scripts/components/pages/LineProducers.js"));

var _BrowserUpgrade = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/BrowserUpgrade */ "./src/scripts/components/pages/BrowserUpgrade.js"));

var _NotFound = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/NotFound */ "./src/scripts/components/pages/NotFound.js"));

var _HeadingPos = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/HeadingPos */ "./src/scripts/components/HeadingPos.js"));

var _Background = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Background */ "./src/scripts/components/Background.js"));

var _GridOverlay = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/GridOverlay */ "./src/scripts/components/GridOverlay.js"));

var _Director = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/Director */ "./src/scripts/components/pages/Director.js"));

var _Nav = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Nav */ "./src/scripts/components/Nav.js"));

var _ScrollWrapper = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/ScrollWrapper */ "./src/scripts/components/ScrollWrapper.js"));

var _VideoPage = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/VideoPage */ "./src/scripts/components/VideoPage.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

var _TransitionRouter = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/TransitionRouter */ "./src/scripts/components/TransitionRouter.js"));

var _Title = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Title */ "./src/scripts/components/Title.js"));

var _isMobile = __webpack_require__(/*! ~/scripts/utils/is-mobile */ "./src/scripts/utils/is-mobile.js");

var _bowser = _interopRequireDefault(__webpack_require__(/*! bowser */ "./node_modules/bowser/es5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Page transition timing
var transitionDuration = 1000;

var App =
/*#__PURE__*/
function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(App)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      previousPathname: null,
      appContext: {
        theme: _app.THEMES.white,
        browserInfo: {}
      },
      posY: 0,
      scrollLocked: false,
      headingPos: null,
      // getBoundingClientRect of heading
      specialPageTransition: false,
      transitionDirection: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPosY", function (posY) {
      _this.setState({
        posY: posY
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setHeadingPos", function (headingPos) {
      _this.setState({
        headingPos: headingPos
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setThemeRed", function () {
      _this.setState(function (_ref) {
        var appContext = _ref.appContext;
        appContext.theme = _app.THEMES.red;
        return {
          appContext: appContext
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setThemeWhite", function () {
      _this.setState(function (_ref2) {
        var appContext = _ref2.appContext;
        appContext.theme = _app.THEMES.white;
        return {
          appContext: appContext
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setThemeBlack", function () {
      _this.setState(function (_ref3) {
        var appContext = _ref3.appContext;
        appContext.theme = _app.THEMES.black;
        return {
          appContext: appContext
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleTheme", function (setToTheme) {
      _this.setState(function (_ref4) {
        var appContext = _ref4.appContext;
        appContext.theme = setToTheme ? setToTheme : appContext.theme === _app.THEMES.red ? _app.THEMES.white : _app.THEMES.red;
        return {
          appContext: appContext
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleSpecialPageTransition", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var allowMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (_isMobile.isMobile && !allowMobile) return;

      _this.setState({
        specialPageTransition: value,
        transitionDirection: direction
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEnter", function (node) {
      if (!_isMobile.isMobile) {
        var posY = _this.state.posY;
        node.style.transform = "translate3d(0, ".concat(posY, "px, 0)"); // Lock scroll

        _this.setState({
          scrollLocked: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEntering", function (node) {
      // If mobile, set timeout to reset the scroll midway the transition
      if (_isMobile.isMobile) {
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, transitionDuration / 2);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEntered", function (node) {
      _this.toggleSpecialPageTransition(false, null, true);

      if (!_isMobile.isMobile) {
        // Reset scroll
        window.scrollTo(0, 0); // Unlock the scroll
        // Reset posY - scroll jack position

        _this.setState({
          posY: 0,
          scrollLocked: false
        }); // Remove translate from the entered node


        node.style.transform = "";
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLocationChange", function (previousPathname, currentPathname) {
      _this.setState({
        previousPathname: previousPathname,
        currentPathname: currentPathname
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFirstSegment", function (pathname) {
      var defaultSegment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "home";
      return pathname && pathname !== "/" ? pathname.split("/")[1] : defaultSegment;
    });

    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var info = _bowser.default.getParser(window.navigator.userAgent).getResult();

      this.setState(function (_ref5) {
        var appContext = _ref5.appContext;
        appContext.browserInfo = info;
        return {
          appContext: appContext
        };
      });

      if (info.browser.name === "Internet Explorer") {
        (0, _router.navigate)("/browser-upgrade");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          posY = _this$state.posY,
          appContext = _this$state.appContext,
          scrollLocked = _this$state.scrollLocked,
          headingPos = _this$state.headingPos,
          previousPathname = _this$state.previousPathname,
          currentPathname = _this$state.currentPathname,
          specialPageTransition = _this$state.specialPageTransition,
          transitionDirection = _this$state.transitionDirection;
      var prev = this.getFirstSegment(previousPathname, "home");
      var next = this.getFirstSegment(currentPathname, "home");
      return _react.default.createElement(_router.Location, null, function (_ref6) {
        var location = _ref6.location;
        return _react.default.createElement(_app.AppContext.Provider, {
          value: appContext
        }, _react.default.createElement(_Title.default, {
          uri: location.pathname
        }), _react.default.createElement(_Background.default, null), _react.default.createElement(_GridOverlay.default, null), _react.default.createElement(_HeadingPos.default, {
          setHeadingPos: _this2.setHeadingPos
        }), _react.default.createElement(_router.Match, {
          path: "videos/:entryType/:slug/:id"
        }, function (_ref7) {
          var match = _ref7.match;
          return match ? null : _react.default.createElement(_Nav.default, null);
        }), _react.default.createElement(_ScrollWrapper.default, {
          default: true,
          posY: posY,
          scrollLocked: scrollLocked,
          setPosY: _this2.setPosY
        }, _react.default.createElement(_TransitionRouter.default, {
          timeout: transitionDuration,
          location: location,
          classNames: "page",
          onEnter: _this2.handleEnter,
          onEntering: _this2.handleEntering,
          onEntered: _this2.handleEntered,
          onLocationChange: _this2.handleLocationChange,
          className: (0, _classnames.default)(specialPageTransition ? "transition-".concat(prev, "-").concat(next).concat(transitionDirection ? "-" + transitionDirection : "") : "transition-default")
        }, function (state) {
          return _react.default.createElement(_router.Router, {
            location: location,
            primary: false
          }, _react.default.createElement(_Home.default, {
            path: "/",
            posY: posY,
            state: state,
            headingPos: headingPos,
            onMount: _this2.setThemeWhite,
            toggleSpecialPageTransition: _this2.toggleSpecialPageTransition
          }), _react.default.createElement(_Director.default, {
            path: "directors/:slug",
            onMount: _this2.toggleTheme,
            state: state,
            headingPos: headingPos,
            transitionDirection: transitionDirection,
            toggleSpecialPageTransition: _this2.toggleSpecialPageTransition
          }), _react.default.createElement(_LineProducers.default, {
            path: "/line-production",
            posY: posY,
            state: state,
            headingPos: headingPos,
            onMount: _this2.setThemeBlack,
            transitionDirection: transitionDirection,
            toggleSpecialPageTransition: _this2.toggleSpecialPageTransition
          }), _react.default.createElement(_About.default, {
            path: "about",
            onMount: _this2.setThemeRed
          }), _react.default.createElement(_BrowserUpgrade.default, {
            path: "browser-upgrade",
            onMount: _this2.setThemeWhite
          }), _react.default.createElement(_NotFound.default, {
            default: true,
            onMount: _this2.setThemeWhite
          }), _react.default.createElement(_VideoPage.default, {
            path: "videos/:entryType/:slug/:id",
            onMount: _this2.setThemeBlack,
            toggleSpecialPageTransition: _this2.toggleSpecialPageTransition
          }));
        })));
      });
    }
  }]);

  return App;
}(_react.Component);
/* eslint-disable-next-line no-undef */


var _default = App;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Background.js":
/*!**********************************************!*\
  !*** ./src/scripts/components/Background.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

var _isMobile = __webpack_require__(/*! ~/scripts/utils/is-mobile */ "./src/scripts/utils/is-mobile.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Background =
/*#__PURE__*/
function (_Component) {
  _inherits(Background, _Component);

  function Background() {
    _classCallCheck(this, Background);

    return _possibleConstructorReturn(this, _getPrototypeOf(Background).apply(this, arguments));
  }

  _createClass(Background, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_isMobile.isMobile) {
        document.body.classList.add("is-mobile");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var theme = this.context.theme;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)("background", "theme-".concat(theme))
      });
    }
  }]);

  return Background;
}(_react.Component);

_defineProperty(Background, "contextType", _app.AppContext);

var _default = Background;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/BodyCopy.js":
/*!********************************************!*\
  !*** ./src/scripts/components/BodyCopy.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BodyCopy =
/*#__PURE__*/
function (_Component) {
  _inherits(BodyCopy, _Component);

  function BodyCopy() {
    _classCallCheck(this, BodyCopy);

    return _possibleConstructorReturn(this, _getPrototypeOf(BodyCopy).apply(this, arguments));
  }

  _createClass(BodyCopy, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.context.theme;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)("body-copy", "theme-".concat(theme))
      }, children);
    }
  }]);

  return BodyCopy;
}(_react.Component);

_defineProperty(BodyCopy, "propTypes", {
  children: _propTypes.default.node
});

_defineProperty(BodyCopy, "contextType", _app.AppContext);

var _default = BodyCopy;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Captions.js":
/*!********************************************!*\
  !*** ./src/scripts/components/Captions.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Captions =
/*#__PURE__*/
function (_Component) {
  _inherits(Captions, _Component);

  function Captions() {
    _classCallCheck(this, Captions);

    return _possibleConstructorReturn(this, _getPrototypeOf(Captions).apply(this, arguments));
  }

  _createClass(Captions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          line1 = _this$props.line1,
          line2 = _this$props.line2;

      if (!line1 && !line2) {
        return null;
      }

      return _react.default.createElement(_react.default.Fragment, null, line1 && _react.default.createElement("div", {
        className: "captions__line1"
      }, line1), line2 && _react.default.createElement("div", {
        className: "captions__line2"
      }, line2));
    }
  }]);

  return Captions;
}(_react.Component);

_defineProperty(Captions, "propTypes", {
  line1: _propTypes.default.string,
  line2: _propTypes.default.string
});

var _default = Captions;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/ContactsList.js":
/*!************************************************!*\
  !*** ./src/scripts/components/ContactsList.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _DetailsCard = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/DetailsCard */ "./src/scripts/components/DetailsCard.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContactsList =
/*#__PURE__*/
function (_Component) {
  _inherits(ContactsList, _Component);

  function ContactsList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContactsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContactsList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderContact", function (contact) {
      var name = contact.name,
          role = contact.role,
          phoneNumber = contact.phoneNumber,
          emailAddress = contact.emailAddress;
      var items = [{
        text: name
      }, {
        text: role
      }, {
        text: phoneNumber,
        href: "tel:".concat(phoneNumber)
      }, {
        text: emailAddress,
        href: "mailto:".concat(emailAddress)
      }];
      return _react.default.createElement(_DetailsCard.default, {
        key: name,
        items: items
      });
    });

    return _this;
  }

  _createClass(ContactsList, [{
    key: "render",
    value: function render() {
      var contacts = this.props.contacts;

      if (!contacts) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "contacts-list"
      }, _react.default.createElement("div", {
        className: "contacts-list__contact"
      }, _react.default.createElement("div", {
        className: "contacts-list__columns"
      }, contacts.map(this.renderContact))));
    }
  }]);

  return ContactsList;
}(_react.Component);

_defineProperty(ContactsList, "propTypes", {
  contacts: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    role: _propTypes.default.string,
    phoneNumber: _propTypes.default.string,
    emailAddress: _propTypes.default.string
  }))
});

var _default = ContactsList;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/DetailsCard.js":
/*!***********************************************!*\
  !*** ./src/scripts/components/DetailsCard.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DetailsCard =
/*#__PURE__*/
function (_Component) {
  _inherits(DetailsCard, _Component);

  function DetailsCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DetailsCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DetailsCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderItem", function (_ref) {
      var href = _ref.href,
          text = _ref.text;
      return _react.default.createElement("li", {
        key: text
      }, href ? _react.default.createElement("a", {
        className: "details-card__link",
        href: href
      }, text) : _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: text
        }
      }));
    });

    return _this;
  }

  _createClass(DetailsCard, [{
    key: "render",
    value: function render() {
      var items = this.props.items;

      if (!items) {
        return null;
      }

      return _react.default.createElement("ul", {
        className: "details-card"
      }, items.map(this.renderItem));
    }
  }]);

  return DetailsCard;
}(_react.Component);

_defineProperty(DetailsCard, "propTypes", {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    href: _propTypes.default.string
  }))
});

var _default = DetailsCard;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/GridOverlay.js":
/*!***********************************************!*\
  !*** ./src/scripts/components/GridOverlay.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GridOverlay =
/*#__PURE__*/
function (_Component) {
  _inherits(GridOverlay, _Component);

  function GridOverlay() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GridOverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GridOverlay)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createGrid", function () {
      var grid = [];
      var columnCount = 16;

      for (var c = 0; c < columnCount; c++) {
        grid.push(_react.default.createElement("div", {
          key: c,
          className: "grid-overlay__column"
        }));
      }

      return grid;
    });

    return _this;
  }

  _createClass(GridOverlay, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "grid-overlay"
      }, this.createGrid());
    }
  }]);

  return GridOverlay;
}(_react.Component);

var _default = GridOverlay;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Heading.js":
/*!*******************************************!*\
  !*** ./src/scripts/components/Heading.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Heading =
/*#__PURE__*/
function (_Component) {
  _inherits(Heading, _Component);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, _getPrototypeOf(Heading).apply(this, arguments));
  }

  _createClass(Heading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          outline = _this$props.outline;
      var _this$context = this.context,
          theme = _this$context.theme,
          browserInfo = _this$context.browserInfo;
      var useAlternate = browserInfo.browser && browserInfo.platform ? browserInfo.browser.name === "Safari" && browserInfo.platform.type === "desktop" : false;
      return _react.default.createElement("h2", {
        className: (0, _classnames.default)("heading", "theme-".concat(theme), {
          "heading--outline": outline,
          "heading--standard": !useAlternate,
          "heading--alternate": useAlternate
        })
      }, children);
    }
  }]);

  return Heading;
}(_react.Component);

_defineProperty(Heading, "propTypes", {
  children: _propTypes.default.node,
  outline: _propTypes.default.bool
});

_defineProperty(Heading, "defaultProps", {
  outline: false
});

_defineProperty(Heading, "contextType", _app.AppContext);

var _default = Heading;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/HeadingPos.js":
/*!**********************************************!*\
  !*** ./src/scripts/components/HeadingPos.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _lodash = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HeadingPos =
/*#__PURE__*/
function (_Component) {
  _inherits(HeadingPos, _Component);

  function HeadingPos(props) {
    var _this;

    _classCallCheck(this, HeadingPos);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HeadingPos).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleResize", function () {
      var setHeadingPos = _this.props.setHeadingPos;

      var rect = _this.ref.current.getBoundingClientRect();

      setHeadingPos(rect);
    });

    _this.ref = _react.default.createRef();
    _this.handleResize = (0, _lodash.debounce)(_this.handleResize, 250);
    return _this;
  }

  _createClass(HeadingPos, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('load', this.handleResize);
      window.addEventListener("resize", this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('load', this.handleResize);
      window.removeEventListener("resize", this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "heading-pos",
        ref: this.ref
      });
    }
  }]);

  return HeadingPos;
}(_react.Component);

_defineProperty(HeadingPos, "propTypes", {
  setHeadingPos: _propTypes.default.func
});

var _default = HeadingPos;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/IndexRoll.js":
/*!*********************************************!*\
  !*** ./src/scripts/components/IndexRoll.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _Heading = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Heading */ "./src/scripts/components/Heading.js"));

var _RollTitle = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/RollTitle */ "./src/scripts/components/RollTitle.js"));

var ease = _interopRequireWildcard(__webpack_require__(/*! ~/scripts/utils/ease */ "./src/scripts/utils/ease.js"));

var _isMobile = __webpack_require__(/*! ~/scripts/utils/is-mobile */ "./src/scripts/utils/is-mobile.js");

var _w = __webpack_require__(/*! ~/scripts/utils/w */ "./src/scripts/utils/w.js");

var _lodash = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");

var _af = __webpack_require__(/*! @gladeye/af */ "./node_modules/@gladeye/af/dist/af.umd.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Links mask / select start
var startProgress = -0.3;
var endProgress = 1.3;

var IndexRoll =
/*#__PURE__*/
function (_Component) {
  _inherits(IndexRoll, _Component);

  // Rect element for list
  function IndexRoll(props) {
    var _this;

    _classCallCheck(this, IndexRoll);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IndexRoll).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTimeoutID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userScroll", true);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listRect", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selected", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      oldScroll: null // listRect: null

    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleResize", function () {
      _this.selectInPosition();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function () {
      if (_isMobile.isMobile) {
        var _window = window,
            pageYOffset = _window.pageYOffset;
        var oldScroll = _this.state.oldScroll;

        if (oldScroll !== pageYOffset) {
          // console.log(pageYOffset);
          _this.setState({
            oldScroll: pageYOffset
          });
        }
      } else {
        // If it was user who scrolled
        if (_this.userScroll) {
          clearTimeout(_this.scrollTimeoutID); // Reset timeout

          _this.scrollTimeoutID = setTimeout(_this.selectInPosition, 300); // Wait 300ms before selecting an item
        } else {
          _this.userScroll = true;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (e, index) {
      if (!_isMobile.isMobile) {
        var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
            selected = _assertThisInitialize.selected;

        var toggleSpecialPageTransition = _this.props.toggleSpecialPageTransition; // If Index of clicked element is not selected one,
        // select it first before activating the link

        if (selected !== index) {
          e.preventDefault();

          _this.select(index);
        } else {
          toggleSpecialPageTransition(true);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "calcProgress", function (top, height) {
      var progress = (_this.w.h / 2 - top) / height;
      progress = Math.round(progress * 1000) / 1000;
      return progress;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectInPosition", function () {
      // Don't select in position for mobile
      if (_isMobile.isMobile) return;
      var _window2 = window,
          pageYOffset = _window2.pageYOffset;
      var _this$props = _this.props,
          posY = _this$props.posY,
          directors = _this$props.directors;
      if (typeof directors === "undefined") return;
      if (_this.listRect === null) return;
      var found = -1;
      var height = _this.listRect.height / directors.length;

      for (var i = 0; i < directors.length; i++) {
        // Calculate .top if page was at TRUE scroll position
        var top = posY + _this.listRect.top + height * i - pageYOffset; // Calculate progress if page was at TRUE scroll position

        var progress = _this.calcProgress(top, height); // Return if progress inbetween 0 and 1
        // If first pr last item, allow extra progress to be selected


        var start = i === 0 ? startProgress : 0;
        var end = i === directors.length - 1 ? endProgress : 1;

        if (progress >= start && progress <= end) {
          found = i;
          break;
        }
      } // If element found at true scroll position, select it


      if (found !== -1) {
        _this.select(found);
      } else {
        _this.selected = null;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", function (index) {
      var _this$props2 = _this.props,
          posY = _this$props2.posY,
          directors = _this$props2.directors;
      var height = _this.listRect.height / directors.length;
      var top = _this.listRect.top + height * index; // Get Y position relative to animated page

      var y = posY + top - _this.w.h / 2 + height / 2; // Make sure next window scroll event doesn't register as human

      _this.userScroll = false;
      window.scrollTo(0, y); // Set selected item to index

      _this.selected = index;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rangeProgress", function (progress, start, end) {
      return (progress - start) / (end - start);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderDirector", function (director, index) {
      var _this$props3 = _this.props,
          state = _this$props3.state,
          headingPos = _this$props3.headingPos,
          directors = _this$props3.directors;

      var _assertThisInitialize2 = _assertThisInitialized(_assertThisInitialized(_this)),
          listRect = _assertThisInitialize2.listRect;

      var maskY = 500;
      var imgY = 0;
      var current = null;
      var transitionY = 0;
      var progress = null; // If ref exists

      if (listRect && listRect.height > 0 && !_isMobile.isMobile) {
        var height = listRect.height / directors.length;
        var top = listRect.top + height * index; // Calculate progress

        progress = _this.calcProgress(top, height);
        var eased = ease.linear(progress); // Set current Link being scrolled through (in the middle)

        if (progress >= 0 && progress <= 1) current = index; // Mask

        maskY = Math.min(Math.max(eased, startProgress), endProgress);
        maskY = _this.rangeProgress(maskY, startProgress, endProgress);
        maskY = 1 - maskY * 2; // maskY = maskY;

        maskY = height * maskY; // Image parallax

        imgY = Math.min(Math.max(eased, -1), 2);
        imgY = 1 - imgY * 2;
        imgY = imgY * 50; // TransitionY for the title when changing page

        if (headingPos) {
          transitionY = Math.round(headingPos.height - top);
        }
      }

      var isSelected = _this.selected === index;
      var uri = "/" + director.uri;
      return _react.default.createElement(_router.Link, {
        className: "index-roll__link ".concat(current === index ? "is-current" : "", " ").concat(progress && progress > 1 ? "is-next" : "", " ").concat(progress && progress < 0 ? "is-prev" : ""),
        onClick: function onClick(e) {
          return _this.handleClick(e, index);
        },
        to: uri,
        key: director.id
      }, _react.default.createElement("div", {
        className: "index-roll__title-wrap",
        style: {
          transform: state === "exiting" && current !== null ? "translate3d(0, ".concat(transitionY, "px, 0)") : ""
        }
      }, _react.default.createElement(_Heading.default, {
        outline: true,
        className: "index-roll__title"
      }, director.title), _react.default.createElement("div", {
        className: "index-roll__mask",
        style: {
          transform: _isMobile.isMobile ? "" : "translate3d(0, ".concat(-maskY, "px, 0)")
        }
      }, _react.default.createElement("div", {
        className: "index-roll__mask-content",
        style: {
          transform: _isMobile.isMobile ? "" : "translate3d(0, ".concat(maskY, "px, 0)")
        }
      }, _react.default.createElement(_Heading.default, {
        outline: false,
        className: "index-roll__title"
      }, director.title)))), _react.default.createElement("div", {
        className: "index-roll__image-container"
      }, _react.default.createElement("div", {
        className: "index-roll__parallax-container",
        style: {
          transform: _isMobile.isMobile ? "" : "translate3d(0, ".concat(-imgY, "px, 0)")
        }
      }, _react.default.createElement("picture", {
        className: "index-roll__image"
      }, _react.default.createElement("source", {
        media: "(max-width: 900px)",
        srcSet: isSelected ? director.poster.mobile : director.poster.thumb
      }), _react.default.createElement("img", {
        src: isSelected ? director.poster.desktop : director.poster.thumb,
        alt: director.title
      })))));
    });

    _this.af = (0, _af.af)();
    _this.w = (0, _w.w)();
    _this.listRef = _react.default.createRef();
    _this.handleResize = (0, _lodash.debounce)(_this.handleResize, 250);
    return _this;
  } // read = () => {
  //     if (this.listRef && this.listRef.current) {
  //         this.listRect = this.listRef.current.getBoundingClientRect();
  //     }
  // };
  // write = () => {
  //     const { listRect } = this;
  //     if (listRect) {
  //         this.setState({ listRect });
  //     }
  // };


  _createClass(IndexRoll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("scroll", this.handleScroll);
      window.addEventListener("resize", this.handleResize);
      this.handleResize(); // this.af.addRead(this.read);
      // this.af.addWrite(this.write);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleResize); // this.af.removeRead(this.read);
      // this.af.removeWrite(this.write);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var directors = this.props.directors; // if (prevProps.directors !== directors) {
      //     this.links = Array(directors.length).fill({});
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          directors = _this$props4.directors,
          isProducer = _this$props4.isProducer;

      if (this.listRef && this.listRef.current) {
        this.listRect = this.listRef.current.getBoundingClientRect();
      }

      var title = isProducer ? "Line Producers" : "Directors";
      return _react.default.createElement("div", {
        className: "index-roll"
      }, _react.default.createElement("div", {
        className: "index-roll__title"
      }, _react.default.createElement(_RollTitle.default, null, title)), _react.default.createElement("div", {
        className: "index-roll__list",
        ref: this.listRef
      }, directors && directors.map(this.renderDirector)));
    }
  }]);

  return IndexRoll;
}(_react.Component);

_defineProperty(IndexRoll, "propTypes", {
  directors: _propTypes.default.array,
  posY: _propTypes.default.number
});

var _default = IndexRoll;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/LocationsList.js":
/*!*************************************************!*\
  !*** ./src/scripts/components/LocationsList.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _DetailsCard = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/DetailsCard */ "./src/scripts/components/DetailsCard.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LocationsList =
/*#__PURE__*/
function (_Component) {
  _inherits(LocationsList, _Component);

  function LocationsList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LocationsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LocationsList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderLocation", function (location) {
      var name = location.name,
          address = location.address,
          phoneNumber = location.phoneNumber;
      var items = [{
        text: name
      }, {
        text: address.replace(/\n/g, "<br>")
      }, {
        text: phoneNumber,
        href: "tel:".concat(phoneNumber)
      }];
      return _react.default.createElement(_DetailsCard.default, {
        key: name,
        items: items
      });
    });

    return _this;
  }

  _createClass(LocationsList, [{
    key: "render",
    value: function render() {
      var locations = this.props.locations;

      if (!locations) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "locations-list"
      }, _react.default.createElement("div", {
        className: "locations-list__contact"
      }, _react.default.createElement("div", {
        className: "locations-list__columns"
      }, locations.map(this.renderLocation))));
    }
  }]);

  return LocationsList;
}(_react.Component);

_defineProperty(LocationsList, "propTypes", {
  locations: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    address: _propTypes.default.string,
    phoneNumber: _propTypes.default.string
  }))
});

var _default = LocationsList;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Nav.js":
/*!***************************************!*\
  !*** ./src/scripts/components/Nav.js ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _Logo = _interopRequireDefault(__webpack_require__(/*! ../elements/Logo */ "./src/scripts/elements/Logo.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NavLink = function NavLink(props) {
  var handleProps = function handleProps(_ref) {
    var isCurrent = _ref.isCurrent;
    return {
      className: (0, _classnames.default)(props.className, {
        "is-active": isCurrent
      })
    };
  };

  return _react.default.createElement(_router.Link, _extends({}, props, {
    getProps: handleProps
  }), props.children);
};

NavLink.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)])
};

var Nav =
/*#__PURE__*/
function (_Component) {
  _inherits(Nav, _Component);

  function Nav() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Nav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Nav)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "prevSt", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      revealed: false,
      innerRevealed: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function () {
      var st = window.pageYOffset;

      if (st > _this.prevSt && st > 100) {
        _this.hide();
      } else {
        _this.reveal();
      }

      _this.prevSt = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "reveal", function () {
      if (_this.state.revealed) return;

      _this.setState({
        revealed: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hide", function () {
      if (!_this.state.revealed) return;

      _this.setState({
        revealed: false
      });
    });

    return _this;
  }

  _createClass(Nav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var theme = this.context.theme;
      var revealed = this.state.revealed;
      return _react.default.createElement("nav", {
        className: (0, _classnames.default)("nav", "theme-".concat(theme), "".concat(revealed ? "is-nav-revealed" : "") //is-nav-revealed
        )
      }, _react.default.createElement("div", {
        className: "nav__inner"
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)("nav__items")
      }, _react.default.createElement(NavLink, {
        className: "nav__link",
        to: "/"
      }, "Directors"), _react.default.createElement(NavLink, {
        className: "nav__link",
        to: "/line-production"
      }, "Line Production"), _react.default.createElement(NavLink, {
        className: "nav__link",
        to: "/about"
      }, "About")), _react.default.createElement(_router.Link, {
        className: "nav__logo",
        to: "/",
        "aria-label": "Home"
      }, _react.default.createElement(_Logo.default, null))));
    }
  }]);

  return Nav;
}(_react.Component);

_defineProperty(Nav, "contextType", _app.AppContext);

var _default = Nav;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Next.js":
/*!****************************************!*\
  !*** ./src/scripts/components/Next.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _Heading = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Heading */ "./src/scripts/components/Heading.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NextLink = function NextLink(_ref) {
  var children = _ref.children,
      uri = _ref.uri,
      onClick = _ref.onClick;
  return uri ? _react.default.createElement(_router.Link, {
    id: "next-director",
    to: "/".concat(uri),
    className: "next__link",
    state: {
      transition: "next"
    },
    onClick: onClick
  }, children) : children;
};

NextLink.propTypes = {
  children: _propTypes.default.node,
  uri: _propTypes.default.string,
  onClick: _propTypes.default.func
};

var Next =
/*#__PURE__*/
function (_Component) {
  _inherits(Next, _Component);

  function Next(props) {
    var _this;

    _classCallCheck(this, Next);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Next).call(this, props));
    _this.keyPress = _this.keyPress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Next, [{
    key: "keyPress",
    value: function keyPress(event) {
      if (event.key == "ArrowRight" && this.props.next) {
        document.getElementById("next-director").click();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.keyPress, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.keyPress, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          next = _this$props.next,
          toggleSpecialPageTransition = _this$props.toggleSpecialPageTransition;
      var theme = this.context.theme;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)("next", "theme-".concat(theme))
      }, _react.default.createElement("div", {
        className: "next__cta"
      }, _react.default.createElement(NextLink, {
        uri: next && next.uri,
        onClick: function onClick() {
          toggleSpecialPageTransition(true, 'next');
        }
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)("next__title", {
          hide: !next
        })
      }, "Next ", title)), _react.default.createElement("div", {
        className: (0, _classnames.default)("next__previous previous__title")
      }, "Previous ", title)), next && _react.default.createElement(NextLink, {
        uri: next.uri,
        onClick: function onClick() {
          toggleSpecialPageTransition(true, 'next');
        }
      }, _react.default.createElement(_Heading.default, {
        className: "next__director"
      }, next.title)));
    }
  }]);

  return Next;
}(_react.Component);

_defineProperty(Next, "propTypes", {
  title: _propTypes.default.string,
  next: _propTypes.default.shape({
    uri: _propTypes.default.string,
    title: _propTypes.default.string,
    onClick: _propTypes.default.func
  })
});

_defineProperty(Next, "contextType", _app.AppContext);

var _default = Next;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Previous.js":
/*!********************************************!*\
  !*** ./src/scripts/components/Previous.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PrevLink = function PrevLink(_ref) {
  var children = _ref.children,
      uri = _ref.uri,
      onClick = _ref.onClick;
  return uri ? _react.default.createElement(_router.Link, {
    id: "prev-director",
    to: "/".concat(uri),
    state: {
      transition: "prev"
    },
    onClick: onClick
  }, children) : children;
};

PrevLink.propTypes = {
  children: _propTypes.default.node,
  uri: _propTypes.default.string,
  onClick: _propTypes.default.func
};

var Previous =
/*#__PURE__*/
function (_Component) {
  _inherits(Previous, _Component);

  function Previous(props) {
    var _this;

    _classCallCheck(this, Previous);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Previous).call(this, props));
    _this.keyPress = _this.keyPress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Previous, [{
    key: "keyPress",
    value: function keyPress(event) {
      if (event.key == "ArrowLeft" && this.props.prev) {
        document.getElementById("prev-director").click();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.keyPress, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.keyPress, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          prev = _this$props.prev,
          toggleSpecialPageTransition = _this$props.toggleSpecialPageTransition;
      var theme = this.context.theme;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)("previous", "theme-".concat(theme))
      }, _react.default.createElement(PrevLink, {
        uri: prev && prev.uri,
        onClick: function onClick() {
          toggleSpecialPageTransition(true, 'previous');
        }
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)("previous__title", {
          hide: !prev
        })
      }, "Previous ", title)), _react.default.createElement("div", {
        className: (0, _classnames.default)("previous__next next__title")
      }, "Next ", title));
    }
  }]);

  return Previous;
}(_react.Component);

_defineProperty(Previous, "propTypes", {
  title: _propTypes.default.string,
  prev: _propTypes.default.shape({
    uri: _propTypes.default.string,
    onClick: _propTypes.default.func
  })
});

_defineProperty(Previous, "contextType", _app.AppContext);

var _default = Previous;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/RollFooter.js":
/*!**********************************************!*\
  !*** ./src/scripts/components/RollFooter.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _RollTitle = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/RollTitle */ "./src/scripts/components/RollTitle.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RollFooter =
/*#__PURE__*/
function (_Component) {
  _inherits(RollFooter, _Component);

  function RollFooter() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RollFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RollFooter)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderFriend", function (friend) {
      return _react.default.createElement("div", {
        key: friend.id,
        className: "roll-footer__item"
      }, _react.default.createElement("a", {
        className: "roll-footer__link",
        href: friend.uri,
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react.default.createElement("img", {
        className: "roll-footer__image",
        src: friend.logo,
        alt: friend.title
      })));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderSocialLink", function (text, link) {
      return !link ? null : _react.default.createElement("a", {
        className: "roll-footer__social",
        href: link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, text);
    });

    return _this;
  }

  _createClass(RollFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          friends = _this$props.friends,
          facebook = _this$props.facebook,
          instagram = _this$props.instagram;
      return _react.default.createElement("div", {
        className: "roll-footer"
      }, _react.default.createElement("div", {
        className: "roll-footer__top"
      }, _react.default.createElement("div", {
        className: "roll-footer__title"
      }, _react.default.createElement(_RollTitle.default, null, "Friends of Exit Films")), _react.default.createElement("div", {
        className: "roll-footer__list"
      }, friends && friends.map(this.renderFriend))), _react.default.createElement("div", {
        className: "roll-footer__bottom"
      }, this.renderSocialLink("Facebook", facebook), this.renderSocialLink("Instagram", instagram)));
    }
  }]);

  return RollFooter;
}(_react.Component);

_defineProperty(RollFooter, "propTypes", {
  friends: _propTypes.default.array,
  facebook: _propTypes.default.string,
  instagram: _propTypes.default.string
});

var _default = RollFooter;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/RollHeader.js":
/*!**********************************************!*\
  !*** ./src/scripts/components/RollHeader.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _animejs = _interopRequireDefault(__webpack_require__(/*! animejs */ "./node_modules/animejs/lib/anime.es.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _VimeoPlayer = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/VimeoPlayer */ "./src/scripts/components/VimeoPlayer.js"));

var _Captions = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Captions */ "./src/scripts/components/Captions.js"));

var _Logo = _interopRequireDefault(__webpack_require__(/*! ~/scripts/elements/Logo */ "./src/scripts/elements/Logo.js"));

var _isMobile = __webpack_require__(/*! ~/scripts/utils/is-mobile */ "./src/scripts/utils/is-mobile.js");

var _w = __webpack_require__(/*! ~/scripts/utils/w */ "./src/scripts/utils/w.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_HEADER_HIDDEN = "is-header-hidden";
var CLASS_SOUND_ON = "is-sound-on";

var RollHeader =
/*#__PURE__*/
function (_Component) {
  _inherits(RollHeader, _Component);

  function RollHeader(props) {
    var _this;

    _classCallCheck(this, RollHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RollHeader).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "whOld", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hOld", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      muted: true,
      isHeaderHiddenMobile: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function () {
      var _window = window,
          pageYOffset = _window.pageYOffset;
      var isHeaderHiddenMobile = _this.state.isHeaderHiddenMobile;

      if (pageYOffset >= _this.w.h / 4 && !isHeaderHiddenMobile) {
        _this.setState({
          isHeaderHiddenMobile: true
        });
      }

      if (pageYOffset < _this.w.h / 4 && isHeaderHiddenMobile) {
        _this.setState({
          isHeaderHiddenMobile: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleResize", function () {
      var height = _this.headerRef.current.clientHeight;

      if (_this.w.h !== 0 && Math.abs(_this.whOld - _this.w.h) > 100 || _this.hOld !== height) {
        _this.whOld = _this.w.h;
        _this.hOld = height;
        var pt = (_this.w.h - height) / 2;

        _this.setState({
          paddingTop: pt > 60 ? pt : 60
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "soundsToggle", function () {
      var muted = _this.state.muted;

      if (muted) {
        (0, _animejs.default)({
          targets: _this.wave.current,
          d: ["M0,3 C10,3 10,15 20,15 C30,15 30,3 40,3 C50,3 50,15 60,15 C70,15 70,3 80,3 C90,3 90,15 100,15 C110,15 110,3 120,3 C130,3 130,15 140,15 C150,15 150,3 160,3"],
          easing: "easeOutQuad",
          duration: 500
        });
      } else {
        (0, _animejs.default)({
          targets: _this.wave.current,
          d: ["M0,9 C10,9 10,11 20,11 C30,11 30,9 40,9 C50,9 50,11 60,11 C70,11 70,9 80,9 C90,9 90,11 100,11 C110,11 110,9 120,9 C130,9 130,11 140,11 C150,11 150,9 160,9"],
          easing: "easeOutQuad",
          duration: 500
        });
      }

      _this.setState({
        muted: !muted
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePlay", function () {
      _this.setState({
        played: true
      });
    });

    _this.headerRef = _react.default.createRef();
    _this.video = _react.default.createRef();
    _this.wave = _react.default.createRef();
    _this.w = (0, _w.w)(); // this.handleResize = debounce(this.handleResize, 250);

    return _this;
  }

  _createClass(RollHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("load", this.handleResize);
      window.addEventListener("resize", this.handleResize);
      this.handleResize();

      if (_isMobile.isMobile) {
        window.addEventListener("scroll", this.handleScroll);
        this.handleScroll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("load", this.handleResize);
      window.removeEventListener("resize", this.handleResize);

      if (_isMobile.isMobile) {
        window.removeEventListener("scroll", this.handleScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          line1 = _this$props.line1,
          line2 = _this$props.line2,
          showReelUrl = _this$props.showReelUrl,
          posY = _this$props.posY,
          scrollLocked = _this$props.scrollLocked,
          poster = _this$props.poster;
      var _this$state = this.state,
          muted = _this$state.muted,
          paddingTop = _this$state.paddingTop,
          played = _this$state.played,
          isHeaderHiddenMobile = _this$state.isHeaderHiddenMobile;
      var isHeaderHidden = false;
      var y = null; // let paddingTop = null;

      if (this.headerRef.current) {
        // const rect = this.headerRef.current.getBoundingClientRect();
        // const progress = (1 - (rect.top + rect.height) / (this.w.h + rect.height));
        // paddingTop = (this.w.h - rect.height) / 2;
        // console.log(this.w.h, rect.height);
        // const progress = 1 - (rect.top + rect.height) / (this.w.h + rect.height);
        if (!scrollLocked) {
          y = _isMobile.isMobile ? null : -posY * 0.1;
        } // y = isMobile ? 0 : (1 - progress*2) * 100;
        // isHeaderHidden = progress > 0.75;


        isHeaderHidden = _isMobile.isMobile ? isHeaderHiddenMobile : posY >= this.w.h / 4; // console.log(isHeaderHidden);
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)("roll-header", _defineProperty({}, CLASS_HEADER_HIDDEN, isHeaderHidden)),
        style: {
          marginTop: paddingTop ? "".concat(paddingTop, "px") : ""
        }
      }, _react.default.createElement("div", {
        ref: this.headerRef,
        className: (0, _classnames.default)("roll-header__inner", _defineProperty({}, CLASS_SOUND_ON, !muted))
      }, _react.default.createElement("div", {
        className: "roll-header__logo",
        style: {
          transform: y ? "translate3d(0, ".concat(y * 3.5, "px, 0)") : ""
        }
      }, _react.default.createElement(_Logo.default, null)), _react.default.createElement("div", {
        className: "roll-header__showreel",
        style: {
          transform: y ? "translate3d(0, ".concat(y, "px, 0)") : ""
        }
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)("roll-header__video", {
          loaded: played
        })
      }, poster && _react.default.createElement("div", {
        className: "roll-header__preview-container"
      }, _react.default.createElement("img", {
        className: "roll-header__preview-image",
        src: poster.thumb,
        alt: "".concat(line1, " - ").concat(line2)
      })), showReelUrl && _react.default.createElement(_VimeoPlayer.default, {
        url: showReelUrl,
        background: true,
        loop: true,
        playing: !isHeaderHidden,
        muted: muted,
        onPlay: this.handlePlay
      }), _react.default.createElement("span", {
        className: (0, _classnames.default)("roll-header__loading", {
          loaded: played
        })
      }, _react.default.createElement("svg", {
        viewBox: "25 25 50 50"
      }, _react.default.createElement("circle", {
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }))), _react.default.createElement("div", {
        className: "roll-header__sound",
        onClick: this.soundsToggle
      }, _react.default.createElement("div", {
        className: "roll-header__wave"
      }, _react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 160 18"
      }, _react.default.createElement("path", {
        ref: this.wave,
        fill: "none",
        stroke: "none",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M0,9 C10,9 10,11 20,11 C30,11 30,9 40,9 C50,9 50,11 60,11 C70,11 70,9 80,9 C90,9 90,11 100,11 C110,11 110,9 120,9 C130,9 130,11 140,11 C150,11 150,9 160,9"
      })))), _react.default.createElement("div", {
        className: "roll-header__caption"
      }, _react.default.createElement(_Captions.default, {
        line1: line1,
        line2: line2
      }))))));
    }
  }]);

  return RollHeader;
}(_react.Component);

_defineProperty(RollHeader, "propTypes", {
  posY: _propTypes.default.number.isRequired,
  line1: _propTypes.default.string,
  line2: _propTypes.default.string,
  showReelUrl: _propTypes.default.string
});

var _default = RollHeader;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/RollTitle.js":
/*!*********************************************!*\
  !*** ./src/scripts/components/RollTitle.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RollTitle =
/*#__PURE__*/
function (_Component) {
  _inherits(RollTitle, _Component);

  function RollTitle() {
    _classCallCheck(this, RollTitle);

    return _possibleConstructorReturn(this, _getPrototypeOf(RollTitle).apply(this, arguments));
  }

  _createClass(RollTitle, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react.default.createElement("div", {
        className: "roll-title"
      }, children);
    }
  }]);

  return RollTitle;
}(_react.Component);

_defineProperty(RollTitle, "propTypes", {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
});

var _default = RollTitle;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/ScrollWrapper.js":
/*!*************************************************!*\
  !*** ./src/scripts/components/ScrollWrapper.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _af = __webpack_require__(/*! @gladeye/af */ "./node_modules/@gladeye/af/dist/af.umd.js");

var _isMobile = __webpack_require__(/*! ~/scripts/utils/is-mobile */ "./src/scripts/utils/is-mobile.js");

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ScrollWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollWrapper, _Component);

  // posY = 0;
  // state = {
  //     posY: 0
  // };
  function ScrollWrapper(props) {
    var _this;

    _classCallCheck(this, ScrollWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollWrapper).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "stopped", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "read", function () {
      _this.prevHeight = _this.height;
      _this.height = _this.wrapperRef.current.clientHeight;
      var _this$props = _this.props,
          scrollLocked = _this$props.scrollLocked,
          setPosY = _this$props.setPosY,
          posY = _this$props.posY;
      var _window = window,
          pageYOffset = _window.pageYOffset;
      if (scrollLocked) return;

      if (_this.prevHeight !== _this.height) {
        document.body.style.height = "".concat(_this.height, "px");
      }

      if (Math.abs(pageYOffset - posY) < 0.2) {
        if (!_this.stopped) {
          setPosY(pageYOffset);
          _this.stopped = true;
        }

        return;
      }

      _this.stopped = false;
      posY += (pageYOffset - posY) * 0.2;
      setPosY(posY);
    });

    _this.af = (0, _af.af)();
    _this.wrapperRef = _react.default.createRef();
    _this.body = document.body;
    return _this;
  }

  _createClass(ScrollWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_isMobile.isMobile) {
        this.af.addRead(this.read); // this.af.addWrite(this.write);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_isMobile.isMobile) {
        this.af.removeRead(this.read); // this.af.removeWrite(this.write);
      }
    }
  }, {
    key: "render",
    // write = () => {
    //     const { setPosY } = this.props;
    //     let { posY } = this;
    //     // this.setState({ posY });
    // };
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          posY = _this$props2.posY;
      return _react.default.createElement("div", {
        className: "scroll-wrapper",
        style: {
          transform: "translate3d(0, ".concat(-posY, "px, 0)")
        },
        ref: this.wrapperRef
      }, children);
    }
  }]);

  return ScrollWrapper;
}(_react.Component);

_defineProperty(ScrollWrapper, "propTypes", {
  posY: _propTypes.default.number,
  setPosY: _propTypes.default.func,
  children: _propTypes.default.node
});

var _default = ScrollWrapper;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Social.js":
/*!******************************************!*\
  !*** ./src/scripts/components/Social.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Social =
/*#__PURE__*/
function (_Component) {
  _inherits(Social, _Component);

  function Social() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Social);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Social)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderSocialLink", function (text, link) {
      return !link ? null : _react.default.createElement("a", {
        className: "social__link",
        href: link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, text);
    });

    return _this;
  }

  _createClass(Social, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          facebook = _this$props.facebook,
          instagram = _this$props.instagram,
          position = _this$props.position;
      var theme = this.context.theme;

      if (!facebook && !instagram) {
        return null;
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)("social", "theme-".concat(theme))
      }, _react.default.createElement("div", {
        className: "social__inner " + position
      }, this.renderSocialLink("Facebook", facebook), this.renderSocialLink("Instagram", instagram)));
    }
  }]);

  return Social;
}(_react.Component);

_defineProperty(Social, "propTypes", {
  facebook: _propTypes.default.string,
  instagram: _propTypes.default.string,
  position: _propTypes.default.oneOf(["left", "right"]).isRequired
});

_defineProperty(Social, "contextType", _app.AppContext);

var _default = Social;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/Title.js":
/*!*****************************************!*\
  !*** ./src/scripts/components/Title.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _reactHelmet = _interopRequireDefault(__webpack_require__(/*! react-helmet */ "./node_modules/react-helmet/lib/Helmet.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Title =
/*#__PURE__*/
function (_Component) {
  _inherits(Title, _Component);

  function Title(props) {
    var _this;

    _classCallCheck(this, Title);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Title).call(this, props));
    _this.state = {};
    _this.fetch = _this.fetch.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Title, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetch();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.uri !== this.props.uri) {
        this.fetch();
      }
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var uri, url, response, meta;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              uri = this.props.uri;
              url = "/actions/seomatic/meta-container/meta-title-container/?uri=".concat(uri, "&asArray=true");
              _context.next = 4;
              return fetch(url);

            case 4:
              response = _context.sent;
              _context.next = 7;
              return response.json();

            case 7:
              meta = _context.sent;
              this.setState(_objectSpread({}, meta));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    })))
  }, {
    key: "render",
    value: function render() {
      var _this$state$MetaTitle = this.state.MetaTitleContainer,
          MetaTitleContainer = _this$state$MetaTitle === void 0 ? {} : _this$state$MetaTitle;
      return _react.default.createElement(_reactHelmet.default, null, MetaTitleContainer && MetaTitleContainer.title && _react.default.createElement("title", null, MetaTitleContainer.title.title));
    }
  }]);

  return Title;
}(_react.Component);

_defineProperty(Title, "propTypes", {
  uri: _propTypes.default.string.isRequired
});

var _default = Title;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/TransitionRouter.js":
/*!****************************************************!*\
  !*** ./src/scripts/components/TransitionRouter.js ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _reactTransitionGroup = __webpack_require__(/*! react-transition-group */ "./node_modules/react-transition-group/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TransitionRouter =
/*#__PURE__*/
function (_Component) {
  _inherits(TransitionRouter, _Component);

  function TransitionRouter() {
    _classCallCheck(this, TransitionRouter);

    return _possibleConstructorReturn(this, _getPrototypeOf(TransitionRouter).apply(this, arguments));
  }

  _createClass(TransitionRouter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          location = _this$props.location,
          onLocationChange = _this$props.onLocationChange;

      if (prevProps.location !== location) {
        if (onLocationChange) {
          onLocationChange(prevProps.location.pathname, location.pathname);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          location = _this$props2.location,
          className = _this$props2.className,
          rest = _objectWithoutProperties(_this$props2, ["children", "location", "className"]);

      return _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
        className: className
      }, _react.default.createElement(_reactTransitionGroup.CSSTransition, _extends({
        key: location.pathname
      }, rest), function (state) {
        return children(state);
      }));
    }
  }]);

  return TransitionRouter;
}(_react.Component);

_defineProperty(TransitionRouter, "propTypes", {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  location: _propTypes.default.object,
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  onLocationChange: _propTypes.default.func
});

var _default = TransitionRouter;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/VideoGallery.js":
/*!************************************************!*\
  !*** ./src/scripts/components/VideoGallery.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _lodash = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");

var _reactEasySwipe = _interopRequireDefault(__webpack_require__(/*! react-easy-swipe */ "./node_modules/react-easy-swipe/lib/index.js"));

var _VideoGalleryItem = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/VideoGalleryItem */ "./src/scripts/components/VideoGalleryItem.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FORMAT = {
  medium: "medium",
  large: "large",
  xLarge: "x-large",
  xxLarge: "xx-large"
};

var VideoGallery =
/*#__PURE__*/
function (_Component) {
  _inherits(VideoGallery, _Component);

  function VideoGallery(props) {
    var _this;

    _classCallCheck(this, VideoGallery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VideoGallery).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSwipeRight", function () {
      var currentIndex = _this.state.currentIndex;
      var newIndex = currentIndex - 1;
      if (newIndex < 0) return;

      _this.setState({
        currentIndex: newIndex,
        switching: true
      });

      setTimeout(function () {
        _this.setState({
          switching: false
        });
      }, 600);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSwipeLeft", function () {
      var currentIndex = _this.state.currentIndex;
      var films = _this.props.films;
      var newIndex = currentIndex + 1;
      if (newIndex > films.length - 1) return;

      _this.setState({
        currentIndex: newIndex,
        switching: true
      });

      setTimeout(function () {
        _this.setState({
          switching: false
        });
      }, 600);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setCurrentIndexFromFilmId", function () {
      var _this$props = _this.props,
          initialFilmId = _this$props.initialFilmId,
          films = _this$props.films;

      if (initialFilmId && films && films.length > 0) {
        var index = films.findIndex(function (film) {
          return film.id === initialFilmId;
        });

        _this.setState({
          currentIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (externalLink) {
      return function (e, index) {
        var toggleSpecialPageTransition = _this.props.toggleSpecialPageTransition;
        var currentIndex = _this.state.currentIndex; // IF clicked NOT a current video

        if (currentIndex !== index) {
          e.preventDefault(); // Otherwise select clicked video

          _this.setState({
            currentIndex: index,
            switching: true
          });

          setTimeout(function () {
            _this.setState({
              switching: false
            });
          }, 600);
        } else {
          // If we clicked the current slide
          if (e.target && e.target.classList.contains("is-video")) {
            toggleSpecialPageTransition(true, null, true);
          }
        }
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransform", function () {
      var format = _this.state.format;

      switch (format) {
        case FORMAT.xxLarge:
          return _this.getTransformValue(2.5, 8, 1);

        case FORMAT.xLarge:
          return _this.getTransformValue(2.25, 9, 0.75);

        case FORMAT.large:
          return _this.getTransformValue(2, 10, 0.5);

        case FORMAT.medium:
          return _this.getTransformValue(2, 10, 0.5);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransformValue", function (offsetColumns, itemColumns, marginColumns) {
      var currentIndex = _this.state.currentIndex;
      var colWidth = 100 / 15;
      return "translateX(".concat(colWidth * offsetColumns - colWidth * (itemColumns + 2 * marginColumns) * currentIndex, "vw)");
    });

    _this.state = {
      currentIndex: 0,
      switching: false,
      format: FORMAT.xLarge
    };
    _this.handleResize = (0, _lodash.throttle)(_this.handleResize.bind(_assertThisInitialized(_assertThisInitialized(_this))), 250);
    return _this;
  }

  _createClass(VideoGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setCurrentIndexFromFilmId();
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var films = this.props.films;

      if (prevProps.films !== films) {
        this.setCurrentIndexFromFilmId();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var format = FORMAT.xxLarge;

      if (window.matchMedia("(max-width: 1680px)").matches) {
        format = FORMAT.xLarge;
      }

      if (window.matchMedia("(max-width: 1170px)").matches) {
        format = FORMAT.large;
      }

      if (window.matchMedia("(max-width: 900px)").matches) {
        format = FORMAT.medium;
      }

      this.setState({
        format: format
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          films = _this$props2.films,
          directorSlug = _this$props2.directorSlug,
          entryType = _this$props2.entryType;
      var _this$state = this.state,
          currentIndex = _this$state.currentIndex,
          switching = _this$state.switching;

      if (!films || films.length === 0) {
        return null;
      }

      var transform = this.getTransform();
      return _react.default.createElement("div", {
        className: "video-gallery"
      }, _react.default.createElement(_reactEasySwipe.default, {
        onSwipeLeft: this.onSwipeLeft,
        onSwipeRight: this.onSwipeRight
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)("video-gallery__container", {
          switching: switching
        }),
        style: {
          transform: transform
        }
      }, films.map(function (film, index) {
        return _react.default.createElement(_VideoGalleryItem.default, {
          key: index,
          film: film,
          entryType: entryType,
          directorSlug: directorSlug,
          index: index,
          isCurrent: currentIndex === index,
          onClick: _this2.handleClick(film.externalLink ? film.externalLink : "")
        });
      }))));
    }
  }]);

  return VideoGallery;
}(_react.Component);

_defineProperty(VideoGallery, "propTypes", {
  films: _propTypes.default.array,
  initialFilmId: _propTypes.default.string,
  toggleSpecialPageTransition: _propTypes.default.func
});

var _default = VideoGallery;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/VideoGalleryItem.js":
/*!****************************************************!*\
  !*** ./src/scripts/components/VideoGalleryItem.js ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

var _Captions = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Captions */ "./src/scripts/components/Captions.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VideoGalleryItem =
/*#__PURE__*/
function (_Component) {
  _inherits(VideoGalleryItem, _Component);

  function VideoGalleryItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VideoGalleryItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VideoGalleryItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (e) {
      var _this$props = _this.props,
          index = _this$props.index,
          onClick = _this$props.onClick;

      if (onClick) {
        onClick(e, index);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderPoster", function (film, isVideo) {
      var isVideoOrImage = isVideo ? "is-video" : "is-image";
      return film.poster && _react.default.createElement("picture", {
        className: "video-gallery-item__image"
      }, _react.default.createElement("source", {
        media: "(max-width: 900px)",
        srcSet: film.poster.mobile
      }), _react.default.createElement("img", {
        className: isVideoOrImage,
        src: film.poster.desktop,
        alt: "".concat(film.line1, " - ").concat(film.line2)
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderLink", function (entryType, directorSlug, film, theme) {
      return _react.default.createElement(_router.Link, {
        to: "/videos/".concat(entryType, "/").concat(directorSlug, "/").concat(film.id),
        className: (0, _classnames.default)("video-gallery-item__poster", "theme-".concat(theme)),
        onClick: _this.handleClick,
        state: {
          theme: theme
        }
      }, _this.renderPoster(film));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderExternalLink", function (entryType, directorSlug, film, theme) {
      return _react.default.createElement("a", {
        onClick: _this.handleClick,
        href: "".concat(film.externalLink),
        target: "_blank",
        className: (0, _classnames.default)("video-gallery-item__poster", "theme-".concat(theme)),
        state: {
          theme: theme
        }
      }, _this.renderPoster(film));
    });

    return _this;
  }

  _createClass(VideoGalleryItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isCurrent = _this$props2.isCurrent,
          film = _this$props2.film,
          directorSlug = _this$props2.directorSlug,
          entryType = _this$props2.entryType;
      var theme = this.context.theme;
      var isVideo = film && film.url && film.url.includes("vimeo");
      var mediaEl = isVideo ? this.renderLink(entryType, directorSlug, film, theme) : this.renderExternalLink(entryType, directorSlug, film, theme);
      return _react.default.createElement("div", {
        className: (0, _classnames.default)("video-gallery-item", {
          "is-current": isCurrent
        })
      }, mediaEl, _react.default.createElement("div", {
        className: (0, _classnames.default)("video-gallery-item__caption", "theme-".concat(theme))
      }, _react.default.createElement(_Captions.default, {
        line1: film.line1,
        line2: film.line2
      })));
    }
  }]);

  return VideoGalleryItem;
}(_react.Component);

_defineProperty(VideoGalleryItem, "propTypes", {
  film: _propTypes.default.object,
  index: _propTypes.default.number,
  isCurrent: _propTypes.default.bool,
  onClick: _propTypes.default.func
});

_defineProperty(VideoGalleryItem, "contextType", _app.AppContext);

var _default = VideoGalleryItem;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/VideoPage.js":
/*!*********************************************!*\
  !*** ./src/scripts/components/VideoPage.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _VimeoPlayer = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/VimeoPlayer */ "./src/scripts/components/VimeoPlayer.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VideoPage =
/*#__PURE__*/
function (_Component) {
  _inherits(VideoPage, _Component);

  function VideoPage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VideoPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VideoPage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      data: {}
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      var toggleSpecialPageTransition = _this.props.toggleSpecialPageTransition;
      toggleSpecialPageTransition(true, null, true);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "videoPlayerOrImage", function (data) {
      var el = "";

      if (data && data.url && data.url.includes("vimeo")) {
        el = _react.default.createElement(_VimeoPlayer.default, {
          url: data.url,
          autoplay: true,
          playsinline: false
        });
      } else if (data && data.url) {
        el = _react.default.createElement("img", {
          className: "posterImage",
          src: data.url
        });
      }

      return el;
    });

    return _this;
  }

  _createClass(VideoPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          slug = _this$props.slug,
          id = _this$props.id,
          onMount = _this$props.onMount;

      if (onMount) {
        onMount();
      }

      this.load(slug, id);
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(slug, id) {
        var response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("/api/films/".concat(slug, "/").concat(id));

              case 2:
                response = _context.sent;
                _context.next = 5;
                return response.json();

              case 5:
                data = _context.sent;
                this.setState({
                  data: data
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          entryType = _this$props2.entryType,
          slug = _this$props2.slug,
          state = _this$props2.location.state;
      var data = this.state.data;
      var theme = state ? state.theme : null;
      var itemElement = this.videoPlayerOrImage(data);
      var closeLink = entryType === "line-production" ? "/".concat(entryType) : "/".concat(entryType, "/").concat(slug);
      return _react.default.createElement("div", {
        className: "video-page"
      }, _react.default.createElement("div", {
        className: "video-page__content"
      }, _react.default.createElement("div", {
        className: "video-page__video"
      }, _react.default.createElement("div", {
        className: "video-page__vimeo"
      }, data && data.url && itemElement), _react.default.createElement(_router.Link, {
        className: "video-page__close",
        to: "".concat(closeLink),
        state: {
          id: data.id,
          theme: theme
        },
        onClick: this.handleClick
      }))));
    }
  }]);

  return VideoPage;
}(_react.Component);

var _default = VideoPage;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/VimeoPlayer.js":
/*!***********************************************!*\
  !*** ./src/scripts/components/VimeoPlayer.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _player = _interopRequireDefault(__webpack_require__(/*! @vimeo/player */ "./node_modules/@vimeo/player/dist/player.es.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VimeoPlayer =
/*#__PURE__*/
function (_Component) {
  _inherits(VimeoPlayer, _Component);

  function VimeoPlayer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VimeoPlayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VimeoPlayer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRef", function (ref) {
      _this.ref = ref;

      if (_this.ref) {
        var playerProps = _objectSpread({}, _this.props);

        delete playerProps.onPlay;
        _this.player = new _player.default(_this.ref, playerProps);

        if (_this.props.onPlay) {
          _this.player.on("play", _this.props.onPlay);
        }
      }
    });

    return _this;
  }

  _createClass(VimeoPlayer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.url !== this.props.url) {
        this.player.loadVideo(this.props.url);
      }

      if (prevProps.playing !== this.props.playing) {
        if (this.props.playing) {
          this.player.play();
        } else {
          this.player.pause();
        }
      }

      if (prevProps.muted !== this.props.muted) {
        this.player.setVolume(this.props.muted ? 0 : 1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "vimeo-player",
        ref: this.handleRef
      });
    }
  }]);

  return VimeoPlayer;
}(_react.Component);

_defineProperty(VimeoPlayer, "propTypes", {
  url: _propTypes.default.string,
  playing: _propTypes.default.bool,
  muted: _propTypes.default.bool,
  color: _propTypes.default.string,
  autoplay: _propTypes.default.bool,
  onPlay: _propTypes.default.func,
  playsinline: _propTypes.default.bool,
  background: _propTypes.default.bool
});

_defineProperty(VimeoPlayer, "defaultProps", {
  color: "ED423A"
});

var _default = VimeoPlayer;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/pages/About.js":
/*!***********************************************!*\
  !*** ./src/scripts/components/pages/About.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _AboutHeader = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/AboutHeader */ "./src/scripts/components/AboutHeader.js"));

var _ContactsList = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/ContactsList */ "./src/scripts/components/ContactsList.js"));

var _LocationsList = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/LocationsList */ "./src/scripts/components/LocationsList.js"));

var _BodyCopy = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/BodyCopy */ "./src/scripts/components/BodyCopy.js"));

var _Social = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Social */ "./src/scripts/components/Social.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var About =
/*#__PURE__*/
function (_Component) {
  _inherits(About, _Component);

  function About() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, About);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(About)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      loading: false
    });

    return _this;
  }

  _createClass(About, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var onMount, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onMount = this.props.onMount;

                if (onMount) {
                  onMount();
                }

                this.setState({
                  loading: true
                });
                _context.next = 5;
                return fetch("/api/about");

              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();

              case 8:
                data = _context.sent;
                this.setState(_objectSpread({
                  loading: false
                }, data));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          bodyCopy = _this$state.bodyCopy,
          contacts = _this$state.contacts,
          headerImage = _this$state.headerImage,
          locations = _this$state.locations,
          socialMediaAccounts = _this$state.socialMediaAccounts;
      return _react.default.createElement("div", {
        className: "page-wrapper"
      }, _react.default.createElement("div", {
        className: "about"
      }, _react.default.createElement(_AboutHeader.default, {
        headerImage: headerImage
      }), _react.default.createElement(_ContactsList.default, {
        contacts: contacts
      }), _react.default.createElement(_LocationsList.default, {
        locations: locations
      }), _react.default.createElement("div", {
        className: "about__body-copy"
      }, _react.default.createElement(_BodyCopy.default, null, _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: bodyCopy
        }
      }))), _react.default.createElement(_Social.default, _extends({}, socialMediaAccounts, {
        position: "left"
      }))));
    }
  }]);

  return About;
}(_react.Component);

_defineProperty(About, "propTypes", {
  onMount: _propTypes.default.func
});

var _default = About;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/pages/BrowserUpgrade.js":
/*!********************************************************!*\
  !*** ./src/scripts/components/pages/BrowserUpgrade.js ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _Heading = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Heading */ "./src/scripts/components/Heading.js"));

var _BodyCopy = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/BodyCopy */ "./src/scripts/components/BodyCopy.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BrowserUpgrade =
/*#__PURE__*/
function (_Component) {
  _inherits(BrowserUpgrade, _Component);

  function BrowserUpgrade() {
    _classCallCheck(this, BrowserUpgrade);

    return _possibleConstructorReturn(this, _getPrototypeOf(BrowserUpgrade).apply(this, arguments));
  }

  _createClass(BrowserUpgrade, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;

      if (onMount) {
        onMount();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "page-wrapper"
      }, _react.default.createElement("div", {
        className: "browser-upgrade"
      }, _react.default.createElement(_Heading.default, null, "Time for an upgrade."), _react.default.createElement(_BodyCopy.default, null, "Head to", " ", _react.default.createElement("a", {
        href: "http://outdatedbrowser.com/",
        rel: "noreferrer noopener",
        target: "_blank"
      }, "this site"), " ", "for a newer browser version and come back to us.")));
    }
  }]);

  return BrowserUpgrade;
}(_react.Component);

_defineProperty(BrowserUpgrade, "propTypes", {
  onMount: _propTypes.default.func
});

var _default = BrowserUpgrade;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/pages/Director.js":
/*!**************************************************!*\
  !*** ./src/scripts/components/pages/Director.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _html2plaintext = _interopRequireDefault(__webpack_require__(/*! html2plaintext */ "./node_modules/html2plaintext/index.js"));

var _Heading = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Heading */ "./src/scripts/components/Heading.js"));

var _Next = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Next */ "./src/scripts/components/Next.js"));

var _Previous = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Previous */ "./src/scripts/components/Previous.js"));

var _VideoGallery = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/VideoGallery */ "./src/scripts/components/VideoGallery.js"));

var _BodyCopy = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/BodyCopy */ "./src/scripts/components/BodyCopy.js"));

var _FadeUp = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/transitions/FadeUp */ "./src/scripts/components/transitions/FadeUp.js"));

var _NotFound = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/NotFound */ "./src/scripts/components/pages/NotFound.js"));

var _w = __webpack_require__(/*! ~/scripts/utils/w */ "./src/scripts/utils/w.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Director =
/*#__PURE__*/
function (_Component) {
  _inherits(Director, _Component);

  function Director(props) {
    var _this;

    _classCallCheck(this, Director);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Director).call(this, props));
    _this.state = {
      data: {}
    };
    _this.nextRef = _react.default.createRef();
    _this.prevRef = _react.default.createRef();
    _this.w = (0, _w.w)();
    _this.load = _this.load.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Director, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          slug = _this$props.slug,
          onMount = _this$props.onMount,
          location = _this$props.location;

      if (onMount) {
        onMount(location.state && location.state.theme);
      }

      this.load(slug);
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(slug) {
        var friend, url, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                friend = this.props.friend;
                url = friend ? "friends" : "directors";
                _context.next = 4;
                return fetch("/api/".concat(url, "/").concat(slug));

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;
                // TODO: fix merging of properties resulting in incorrect next value
                this.setState({
                  data: data
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load(_x) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "render",
    value: function render() {
      var data = this.state.data;
      var _this$props2 = this.props,
          friend = _this$props2.friend,
          headingPos = _this$props2.headingPos,
          state = _this$props2.state,
          toggleSpecialPageTransition = _this$props2.toggleSpecialPageTransition,
          transitionDirection = _this$props2.transitionDirection,
          location = _this$props2.location,
          slug = _this$props2.slug;
      var transitionX = null;
      var transitionY = null;

      if (state === "exiting") {
        if (transitionDirection === "previous") {
          var rect = this.prevRef.current.getBoundingClientRect();
          transitionY = this.w.h;
          transitionX = this.w.w - rect.left;
        }

        if (transitionDirection === "next") {
          var _rect = this.nextRef.current.getBoundingClientRect();

          transitionY = headingPos.height - _rect.top;
          transitionX = headingPos.left - _rect.left;
        }
      }

      if (state === "entering") {
        if (transitionDirection === "next") {
          var _rect2 = this.nextRef.current.getBoundingClientRect();

          transitionY = this.w.h - _rect2.top;
          transitionX = this.w.w - _rect2.left;
        }
      }

      if (data.error) {
        return _react.default.createElement(_NotFound.default, null);
      }

      var title = data.title,
          bodyCopy = data.bodyCopy,
          prev = data.prev,
          next = data.next,
          films = data.films;
      var description = (0, _html2plaintext.default)(bodyCopy).split("\n\n", 1)[0].trim();
      return _react.default.createElement("div", {
        className: "page-wrapper"
      }, _react.default.createElement("div", {
        className: "director",
        style: {
          transform: transitionX !== null && transitionY !== null ? "translate3d(".concat(transitionX, "px, ").concat(transitionY, "px, 0)") : ""
        }
      }, _react.default.createElement("div", {
        className: "director__head",
        ref: this.prevRef
      }, _react.default.createElement("div", {
        className: "director__sub"
      }, _react.default.createElement(_Previous.default, {
        prev: prev,
        title: friend ? "Friend" : "Director",
        toggleSpecialPageTransition: toggleSpecialPageTransition
      })), _react.default.createElement("div", {
        className: "director__heading"
      }, _react.default.createElement(_Heading.default, null, title))), _react.default.createElement("div", {
        className: "director__body"
      }, _react.default.createElement("div", {
        className: "director__gallery"
      }, _react.default.createElement(_VideoGallery.default, {
        initialFilmId: location.state && location.state.id,
        entryType: friend ? "friends" : "directors",
        directorSlug: slug,
        films: films,
        toggleSpecialPageTransition: toggleSpecialPageTransition
      })), _react.default.createElement("div", {
        className: "director__biography"
      }, _react.default.createElement(_FadeUp.default, null, _react.default.createElement(_BodyCopy.default, null, _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: bodyCopy
        }
      }))))), _react.default.createElement("div", {
        className: "director__next",
        ref: this.nextRef
      }, _react.default.createElement(_Next.default, {
        next: next,
        title: friend ? "Friend" : "Director",
        toggleSpecialPageTransition: toggleSpecialPageTransition
      }))));
    }
  }]);

  return Director;
}(_react.Component);

_defineProperty(Director, "propTypes", {
  slug: _propTypes.default.string,
  location: _propTypes.default.shape({
    state: _propTypes.default.object,
    key: _propTypes.default.string
  }),
  onMount: _propTypes.default.func,
  onChange: _propTypes.default.func,
  friend: _propTypes.default.bool
});

var _default = Director;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/pages/Home.js":
/*!**********************************************!*\
  !*** ./src/scripts/components/pages/Home.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _RollHeader = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/RollHeader */ "./src/scripts/components/RollHeader.js"));

var _IndexRoll = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/IndexRoll */ "./src/scripts/components/IndexRoll.js"));

var _RollFooter = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/RollFooter */ "./src/scripts/components/RollFooter.js"));

var _FadeUp = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/transitions/FadeUp */ "./src/scripts/components/transitions/FadeUp.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var friends = [{
  id: "64",
  title: "Reset",
  uri: "http://www.resetcontent.com/",
  logo: __webpack_require__(/*! ~/images/friends/reset.svg */ "./src/images/friends/reset.svg")
}, {
  id: "63",
  title: "Smuggler",
  uri: "https://smugglersite.com/",
  logo: __webpack_require__(/*! ~/images/friends/smuggler.svg */ "./src/images/friends/smuggler.svg")
}];

var Home =
/*#__PURE__*/
function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Home);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Home)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      loading: false,
      content: {}
    });

    return _this;
  }

  _createClass(Home, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var onMount, response, data, heroVideosData, randomVideoIndex, randomVideoSelection, heroVideo, directors;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onMount = this.props.onMount;

                if (onMount) {
                  onMount();
                }

                this.setState({
                  loading: true
                });
                _context.next = 5;
                return fetch("/api/home");

              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();

              case 8:
                data = _context.sent;
                heroVideosData = data.heroVideos;
                randomVideoIndex = heroVideosData && heroVideosData.length ? Math.floor(Math.random() * heroVideosData.length) : 0;
                randomVideoSelection = data.randomVideoSelection;
                heroVideo = heroVideosData && (randomVideoSelection ? heroVideosData[randomVideoIndex] : heroVideosData[0]);
                directors = data.directorsList;

                if (data.randomDirectorOrder) {
                  directors = directors.sort(function () {
                    return Math.random() - 0.5;
                  });
                }

                this.setState({
                  loading: false,
                  content: {
                    heroVideo: heroVideo,
                    socialMediaAccounts: data.socialMediaAccounts,
                    directors: directors
                  }
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          posY = _this$props.posY,
          setPrevLocation = _this$props.setPrevLocation,
          state = _this$props.state,
          headingPos = _this$props.headingPos,
          toggleSpecialPageTransition = _this$props.toggleSpecialPageTransition;
      var _this$state = this.state,
          loading = _this$state.loading,
          content = _this$state.content;
      var socialMediaAccounts = content.socialMediaAccounts,
          heroVideo = content.heroVideo,
          directors = content.directors;
      return _react.default.createElement("div", {
        className: "page-wrapper"
      }, _react.default.createElement("div", {
        className: "home"
      }, heroVideo && _react.default.createElement(_RollHeader.default, {
        posY: posY,
        showReelUrl: heroVideo.showReelUrl,
        line1: heroVideo.line1,
        line2: heroVideo.line2,
        poster: heroVideo.poster
      }), _react.default.createElement(_FadeUp.default, {
        pose: loading ? "exit" : "enter"
      }, _react.default.createElement(_IndexRoll.default, {
        state: state,
        headingPos: headingPos,
        directors: directors,
        posY: posY,
        setPrevLocation: setPrevLocation,
        toggleSpecialPageTransition: toggleSpecialPageTransition
      }), _react.default.createElement(_RollFooter.default, _extends({
        friends: friends
      }, socialMediaAccounts)))));
    }
  }]);

  return Home;
}(_react.Component);

_defineProperty(Home, "propTypes", {
  onMount: _propTypes.default.func,
  setPrevLocation: _propTypes.default.func,
  state: _propTypes.default.string,
  headingPos: _propTypes.default.object,
  toggleSpecialPageTransition: _propTypes.default.func,
  posY: _propTypes.default.number
});

var _default = Home;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/pages/LineProducers.js":
/*!*******************************************************!*\
  !*** ./src/scripts/components/pages/LineProducers.js ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _html2plaintext = _interopRequireDefault(__webpack_require__(/*! html2plaintext */ "./node_modules/html2plaintext/index.js"));

var _Heading = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Heading */ "./src/scripts/components/Heading.js"));

var _Next = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Next */ "./src/scripts/components/Next.js"));

var _Previous = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Previous */ "./src/scripts/components/Previous.js"));

var _VideoGallery = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/VideoGallery */ "./src/scripts/components/VideoGallery.js"));

var _BodyCopy = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/BodyCopy */ "./src/scripts/components/BodyCopy.js"));

var _FadeUp = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/transitions/FadeUp */ "./src/scripts/components/transitions/FadeUp.js"));

var _NotFound = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/pages/NotFound */ "./src/scripts/components/pages/NotFound.js"));

var _w = __webpack_require__(/*! ~/scripts/utils/w */ "./src/scripts/utils/w.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LineProducers =
/*#__PURE__*/
function (_Component) {
  _inherits(LineProducers, _Component);

  function LineProducers(props) {
    var _this;

    _classCallCheck(this, LineProducers);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LineProducers).call(this, props));
    _this.state = {
      data: {}
    };
    _this.nextRef = _react.default.createRef();
    _this.prevRef = _react.default.createRef();
    _this.w = (0, _w.w)();
    _this.load = _this.load.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(LineProducers, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          slug = _this$props.slug,
          onMount = _this$props.onMount,
          location = _this$props.location;

      if (onMount) {
        onMount(location.state && location.state.theme);
      }

      this.load(slug);
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(slug) {
        var url, requestUrl, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "lineproduction";
                requestUrl = "/api/".concat(url);
                _context.next = 4;
                return fetch(requestUrl);

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;
                // TODO: fix merging of properties resulting in incorrect next value
                this.setState({
                  data: data
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load(_x) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "render",
    value: function render() {
      var data = this.state.data;
      var _this$props2 = this.props,
          headingPos = _this$props2.headingPos,
          state = _this$props2.state,
          toggleSpecialPageTransition = _this$props2.toggleSpecialPageTransition,
          transitionDirection = _this$props2.transitionDirection,
          location = _this$props2.location;
      var transitionX = null;
      var transitionY = null;

      if (state === "exiting") {
        if (transitionDirection === "previous") {
          var rect = this.prevRef.current.getBoundingClientRect();
          transitionY = this.w.h;
          transitionX = this.w.w - rect.left;
        }

        if (transitionDirection === "next") {
          var _rect = this.nextRef.current.getBoundingClientRect();

          transitionY = headingPos.height - _rect.top;
          transitionX = headingPos.left - _rect.left;
        }
      }

      if (state === "entering") {
        if (transitionDirection === "next") {
          var _rect2 = this.nextRef.current.getBoundingClientRect();

          transitionY = this.w.h - _rect2.top;
          transitionX = this.w.w - _rect2.left;
        }
      }

      if (data.error) {
        console.log({
          data: data
        });
        return _react.default.createElement(_NotFound.default, null);
      }

      var title = data.title,
          bodyCopy = data.bodyCopy,
          prev = data.prev,
          next = data.next,
          films = data.films,
          slug = data.slug;
      var description = (0, _html2plaintext.default)(bodyCopy).split("\n\n", 1)[0].trim();
      return _react.default.createElement("div", {
        className: "page-wrapper"
      }, _react.default.createElement("div", {
        className: "line-producer",
        style: {
          transform: transitionX !== null && transitionY !== null ? "translate3d(".concat(transitionX, "px, ").concat(transitionY, "px, 0)") : ""
        }
      }, _react.default.createElement("div", {
        className: "line-producer__head",
        ref: this.prevRef
      }, _react.default.createElement("div", {
        className: "line-producer__heading"
      }, _react.default.createElement(_Heading.default, null, "Line Production"))), _react.default.createElement("div", {
        className: "line-producer__body"
      }, _react.default.createElement("div", {
        className: "line-producer__gallery"
      }, _react.default.createElement(_VideoGallery.default, {
        initialFilmId: location.state && location.state.id,
        entryType: "line-production",
        directorSlug: slug,
        films: films,
        toggleSpecialPageTransition: toggleSpecialPageTransition
      })), _react.default.createElement("div", {
        className: "line-producer__biography"
      }, _react.default.createElement(_FadeUp.default, null, _react.default.createElement(_BodyCopy.default, null, _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: bodyCopy
        }
      })))))));
    }
  }]);

  return LineProducers;
}(_react.Component);

_defineProperty(LineProducers, "propTypes", {
  slug: _propTypes.default.string,
  location: _propTypes.default.shape({
    state: _propTypes.default.object,
    key: _propTypes.default.string
  }),
  onMount: _propTypes.default.func,
  onChange: _propTypes.default.func
});

var _default = LineProducers;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/pages/NotFound.js":
/*!**************************************************!*\
  !*** ./src/scripts/components/pages/NotFound.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _propTypes = _interopRequireDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));

var _router = __webpack_require__(/*! @reach/router */ "./node_modules/@reach/router/es/index.js");

var _Heading = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/Heading */ "./src/scripts/components/Heading.js"));

var _BodyCopy = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/BodyCopy */ "./src/scripts/components/BodyCopy.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotFound =
/*#__PURE__*/
function (_Component) {
  _inherits(NotFound, _Component);

  function NotFound() {
    _classCallCheck(this, NotFound);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotFound).apply(this, arguments));
  }

  _createClass(NotFound, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;

      if (onMount) {
        onMount();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "page-wrapper"
      }, _react.default.createElement("div", {
        className: "not-found"
      }, _react.default.createElement(_Heading.default, null, "Nothing to see here."), _react.default.createElement(_BodyCopy.default, null, "All the good stuff is on our", " ", _react.default.createElement(_router.Link, {
        to: "/"
      }, "Homepage"), ".")));
    }
  }]);

  return NotFound;
}(_react.Component);

_defineProperty(NotFound, "propTypes", {
  onMount: _propTypes.default.func
});

var _default = NotFound;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/components/transitions/FadeUp.js":
/*!******************************************************!*\
  !*** ./src/scripts/components/transitions/FadeUp.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactPose = _interopRequireDefault(__webpack_require__(/*! react-pose */ "./node_modules/react-pose/dist/react-pose.es.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FadeUp = _reactPose.default.div({
  preEnter: {
    y: "5vh",
    opacity: 0,
    transition: {
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  },
  enter: {
    y: "0",
    opacity: 1,
    transition: {
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  },
  exit: {
    y: "5vh",
    opacity: 0,
    transition: {
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
});

var _default = FadeUp;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/context/app.js":
/*!************************************!*\
  !*** ./src/scripts/context/app.js ***!
  \************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContext = exports.THEMES = void 0;

var _react = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var THEMES = {
  black: "black",
  red: "red",
  white: "white"
};
exports.THEMES = THEMES;
var AppContext = (0, _react.createContext)({
  theme: THEMES.white,
  changeTheme: function changeTheme() {},
  browserInfo: {}
});
exports.AppContext = AppContext;

/***/ }),

/***/ "./src/scripts/elements/Logo.js":
/*!**************************************!*\
  !*** ./src/scripts/elements/Logo.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _app = __webpack_require__(/*! ~/scripts/context/app */ "./src/scripts/context/app.js");

var _classnames = _interopRequireDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Logo =
/*#__PURE__*/
function (_Component) {
  _inherits(Logo, _Component);

  function Logo() {
    _classCallCheck(this, Logo);

    return _possibleConstructorReturn(this, _getPrototypeOf(Logo).apply(this, arguments));
  }

  _createClass(Logo, [{
    key: "render",
    value: function render() {
      var theme = this.context.theme;
      return _react.default.createElement("svg", {
        className: (0, _classnames.default)("logo", "theme-".concat(theme)),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 368 140"
      }, _react.default.createElement("polygon", {
        className: (0, _classnames.default)("logo__element", "logo__e"),
        points: "0,0 71.28,0 71.28,21.07 24.31,21.07 24.31,34.61 66.85,34.61 66.85,54.15 24.31,54.15 24.31,68.33 71.91,68.33 71.91,89.4 0,89.4"
      }), _react.default.createElement("polygon", {
        className: (0, _classnames.default)("logo__element", "logo__x"),
        points: "133.68,43.93 104.56,0 132.8,0 148.5,25.16 164.32,0 191.92,0 162.8,43.68 193.19,89.4 164.95,89.4 147.99,62.45 130.9,89.4 103.3,89.4"
      }), _react.default.createElement("rect", {
        className: (0, _classnames.default)("logo__element", "logo__i"),
        x: "228.25",
        width: "24.69",
        height: "89.4"
      }), _react.default.createElement("polygon", {
        className: (0, _classnames.default)("logo__element", "logo__t"),
        points: "316.1,21.71 289.52,21.71 289.52,0 367.25,0 367.25,21.71 340.66,21.71 340.66,89.4 316.1,89.4"
      }), _react.default.createElement("rect", {
        className: (0, _classnames.default)("logo__element", "logo__underscore"),
        x: "103.44",
        y: "114.58",
        width: "89.61",
        height: "24.9"
      }));
    }
  }]);

  return Logo;
}(_react.Component);

_defineProperty(Logo, "contextType", _app.AppContext);

var _default = Logo;
exports.default = _default;

/***/ }),

/***/ "./src/scripts/lib/autotrack.js":
/*!**************************************!*\
  !*** ./src/scripts/lib/autotrack.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

(function () {
  var f = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, d) {
    if (d.get || d.set) throw new TypeError("ES3 does not support getters and setters.");
    a != Array.prototype && a != Object.prototype && (a[b] = d.value);
  },
      g = "undefined" != typeof window && window === this ? this : "undefined" != typeof global && null != global ? global : this;

  function h() {
    h = function h() {};

    g.Symbol || (g.Symbol = k);
  }

  var m = 0;

  function k(a) {
    return "jscomp_symbol_" + (a || "") + m++;
  }

  function n() {
    h();
    var a = g.Symbol.iterator;
    a || (a = g.Symbol.iterator = g.Symbol("iterator"));
    "function" != typeof Array.prototype[a] && f(Array.prototype, a, {
      configurable: !0,
      writable: !0,
      value: function value() {
        return q(this);
      }
    });

    n = function n() {};
  }

  function q(a) {
    var b = 0;
    return r(function () {
      return b < a.length ? {
        done: !1,
        value: a[b++]
      } : {
        done: !0
      };
    });
  }

  function r(a) {
    n();
    a = {
      next: a
    };

    a[g.Symbol.iterator] = function () {
      return this;
    };

    return a;
  }

  function t(a) {
    if (!(a instanceof Array)) {
      n();
      var b = a[Symbol.iterator];
      a = b ? b.call(a) : q(a);

      for (var d = []; !(b = a.next()).done;) {
        d.push(b.value);
      }

      a = d;
    }

    return a;
  }

  var u = [];

  function v(a, b) {
    var d = this;
    this.context = a;
    this.h = b;
    this.f = (this.c = /Task$/.test(b)) ? a.get(b) : a[b];
    this.a = [];
    this.b = [];

    this.g = function (a) {
      for (var b = [], c = 0; c < arguments.length; ++c) {
        b[c - 0] = arguments[c];
      }

      return d.b[d.b.length - 1].apply(null, [].concat(t(b)));
    };

    this.c ? a.set(b, this.g) : a[b] = this.g;
  }

  function w(a, b) {
    b = a.a.indexOf(b);
    -1 < b && (a.a.splice(b, 1), 0 < a.a.length ? x(a) : (b = u.indexOf(a), -1 < b && (u.splice(b, 1), a.c ? a.context.set(a.h, a.f) : a.context[a.h] = a.f)));
  }

  function x(a) {
    a.b = [];

    for (var b, d = 0; b = a.a[d]; d++) {
      var c = a.b[d - 1] || a.f.bind(a.context);
      a.b.push(b(c));
    }
  }

  function y(a) {
    var b = history,
        d = u.filter(function (c) {
      return c.context == b && c.h == a;
    })[0];
    d || (d = new v(b, a), u.push(d));
    return d;
  }

  function z(a, b, d) {
    var c = {
      transport: "beacon"
    };

    if ("function" == typeof d) {
      var e = b.get("buildHitTask");
      return {
        buildHitTask: function buildHitTask(b) {
          b.set(c, null, !0);
          b.set(a, null, !0);
          d(b, void 0, void 0);
          e(b);
        }
      };
    }

    return A({}, c, a);
  }

  var A = Object.assign || function (a, b) {
    for (var d = [], c = 1; c < arguments.length; ++c) {
      d[c - 1] = arguments[c];
    }

    for (var c = 0, e = d.length; c < e; c++) {
      var p = Object(d[c]),
          l;

      for (l in p) {
        Object.prototype.hasOwnProperty.call(p, l) && (a[l] = p[l]);
      }
    }

    return a;
  },
      B = {
    l: 1,
    m: 2,
    o: 3,
    u: 4,
    v: 5,
    w: 6,
    A: 7,
    B: 8,
    j: 9,
    s: 10
  },
      C = Object.keys(B).length;

  function D(a, b) {
    var d = B.j;
    a.set("\x26_av", "2.4.1");
    var c = a.get("\x26_au"),
        c = parseInt(c || "0", 16).toString(2);
    if (c.length < C) for (var e = C - c.length; e;) {
      c = "0" + c, e--;
    }
    d = C - d;
    c = c.substr(0, d) + 1 + c.substr(d + 1);
    a.set("\x26_au", parseInt(c || "0", 2).toString(16));
    history.pushState && window.addEventListener && (this.b = A({
      shouldTrackUrlChange: this.shouldTrackUrlChange,
      trackReplaceState: !1,
      fieldsObj: {},
      hitFilter: null
    }, b), this.g = a, this.i = location.pathname + location.search, this.c = this.c.bind(this), this.f = this.f.bind(this), this.a = this.a.bind(this), a = this.c, b = y("pushState"), b.a.push(a), x(b), a = this.f, b = y("replaceState"), b.a.push(a), x(b), window.addEventListener("popstate", this.a));
  }

  D.prototype.c = function (a) {
    var b = this;
    return function (d) {
      for (var c = [], e = 0; e < arguments.length; ++e) {
        c[e - 0] = arguments[e];
      }

      a.apply(null, [].concat(t(c)));
      E(b, !0);
    };
  };

  D.prototype.f = function (a) {
    var b = this;
    return function (d) {
      for (var c = [], e = 0; e < arguments.length; ++e) {
        c[e - 0] = arguments[e];
      }

      a.apply(null, [].concat(t(c)));
      E(b, !1);
    };
  };

  D.prototype.a = function () {
    E(this, !0);
  };

  function E(a, b) {
    setTimeout(function () {
      var d = a.i,
          c = location.pathname + location.search;
      d != c && a.b.shouldTrackUrlChange.call(a, c, d) && (a.i = c, a.g.set({
        page: c,
        title: document.title
      }), (b || a.b.trackReplaceState) && a.g.send("pageview", z(a.b.fieldsObj, a.g, a.b.hitFilter)));
    }, 0);
  }

  D.prototype.shouldTrackUrlChange = function (a, b) {
    return !(!a || !b);
  };

  D.prototype.remove = function () {
    var a = this.c;
    w(y("pushState"), a);
    a = this.f;
    w(y("replaceState"), a);
    window.removeEventListener("popstate", this.a);
  };

  (function (a, b) {
    var d = window.GoogleAnalyticsObject || "ga";

    window[d] = window[d] || function (a) {
      for (var b = [], c = 0; c < arguments.length; ++c) {
        b[c - 0] = arguments[c];
      }

      (window[d].q = window[d].q || []).push(b);
    };

    window.gaDevIds = window.gaDevIds || [];
    0 > window.gaDevIds.indexOf("i5iSjo") && window.gaDevIds.push("i5iSjo");
    window[d]("provide", a, b);
    window.gaplugins = window.gaplugins || {};
    window.gaplugins[a.charAt(0).toUpperCase() + a.slice(1)] = b;
  })("urlChangeTracker", D);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/scripts/main.js":
/*!*****************************!*\
  !*** ./src/scripts/main.js ***!
  \*****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! core-js/modules/es6.array.copy-within */ "./node_modules/core-js/modules/es6.array.copy-within.js");

__webpack_require__(/*! core-js/modules/es6.array.every */ "./node_modules/core-js/modules/es6.array.every.js");

__webpack_require__(/*! core-js/modules/es6.array.fill */ "./node_modules/core-js/modules/es6.array.fill.js");

__webpack_require__(/*! core-js/modules/es6.array.filter */ "./node_modules/core-js/modules/es6.array.filter.js");

__webpack_require__(/*! core-js/modules/es6.array.find */ "./node_modules/core-js/modules/es6.array.find.js");

__webpack_require__(/*! core-js/modules/es6.array.find-index */ "./node_modules/core-js/modules/es6.array.find-index.js");

__webpack_require__(/*! core-js/modules/es6.array.for-each */ "./node_modules/core-js/modules/es6.array.for-each.js");

__webpack_require__(/*! core-js/modules/es6.array.from */ "./node_modules/core-js/modules/es6.array.from.js");

__webpack_require__(/*! core-js/modules/es7.array.includes */ "./node_modules/core-js/modules/es7.array.includes.js");

__webpack_require__(/*! core-js/modules/es6.array.index-of */ "./node_modules/core-js/modules/es6.array.index-of.js");

__webpack_require__(/*! core-js/modules/es6.array.is-array */ "./node_modules/core-js/modules/es6.array.is-array.js");

__webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");

__webpack_require__(/*! core-js/modules/es6.array.last-index-of */ "./node_modules/core-js/modules/es6.array.last-index-of.js");

__webpack_require__(/*! core-js/modules/es6.array.map */ "./node_modules/core-js/modules/es6.array.map.js");

__webpack_require__(/*! core-js/modules/es6.array.of */ "./node_modules/core-js/modules/es6.array.of.js");

__webpack_require__(/*! core-js/modules/es6.array.reduce */ "./node_modules/core-js/modules/es6.array.reduce.js");

__webpack_require__(/*! core-js/modules/es6.array.reduce-right */ "./node_modules/core-js/modules/es6.array.reduce-right.js");

__webpack_require__(/*! core-js/modules/es6.array.some */ "./node_modules/core-js/modules/es6.array.some.js");

__webpack_require__(/*! core-js/modules/es6.array.sort */ "./node_modules/core-js/modules/es6.array.sort.js");

__webpack_require__(/*! core-js/modules/es6.array.species */ "./node_modules/core-js/modules/es6.array.species.js");

__webpack_require__(/*! core-js/modules/es6.date.now */ "./node_modules/core-js/modules/es6.date.now.js");

__webpack_require__(/*! core-js/modules/es6.date.to-iso-string */ "./node_modules/core-js/modules/es6.date.to-iso-string.js");

__webpack_require__(/*! core-js/modules/es6.date.to-json */ "./node_modules/core-js/modules/es6.date.to-json.js");

__webpack_require__(/*! core-js/modules/es6.date.to-primitive */ "./node_modules/core-js/modules/es6.date.to-primitive.js");

__webpack_require__(/*! core-js/modules/es6.date.to-string */ "./node_modules/core-js/modules/es6.date.to-string.js");

__webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");

__webpack_require__(/*! core-js/modules/es6.function.has-instance */ "./node_modules/core-js/modules/es6.function.has-instance.js");

__webpack_require__(/*! core-js/modules/es6.function.name */ "./node_modules/core-js/modules/es6.function.name.js");

__webpack_require__(/*! core-js/modules/es6.map */ "./node_modules/core-js/modules/es6.map.js");

__webpack_require__(/*! core-js/modules/es6.math.acosh */ "./node_modules/core-js/modules/es6.math.acosh.js");

__webpack_require__(/*! core-js/modules/es6.math.asinh */ "./node_modules/core-js/modules/es6.math.asinh.js");

__webpack_require__(/*! core-js/modules/es6.math.atanh */ "./node_modules/core-js/modules/es6.math.atanh.js");

__webpack_require__(/*! core-js/modules/es6.math.cbrt */ "./node_modules/core-js/modules/es6.math.cbrt.js");

__webpack_require__(/*! core-js/modules/es6.math.clz32 */ "./node_modules/core-js/modules/es6.math.clz32.js");

__webpack_require__(/*! core-js/modules/es6.math.cosh */ "./node_modules/core-js/modules/es6.math.cosh.js");

__webpack_require__(/*! core-js/modules/es6.math.expm1 */ "./node_modules/core-js/modules/es6.math.expm1.js");

__webpack_require__(/*! core-js/modules/es6.math.fround */ "./node_modules/core-js/modules/es6.math.fround.js");

__webpack_require__(/*! core-js/modules/es6.math.hypot */ "./node_modules/core-js/modules/es6.math.hypot.js");

__webpack_require__(/*! core-js/modules/es6.math.imul */ "./node_modules/core-js/modules/es6.math.imul.js");

__webpack_require__(/*! core-js/modules/es6.math.log1p */ "./node_modules/core-js/modules/es6.math.log1p.js");

__webpack_require__(/*! core-js/modules/es6.math.log10 */ "./node_modules/core-js/modules/es6.math.log10.js");

__webpack_require__(/*! core-js/modules/es6.math.log2 */ "./node_modules/core-js/modules/es6.math.log2.js");

__webpack_require__(/*! core-js/modules/es6.math.sign */ "./node_modules/core-js/modules/es6.math.sign.js");

__webpack_require__(/*! core-js/modules/es6.math.sinh */ "./node_modules/core-js/modules/es6.math.sinh.js");

__webpack_require__(/*! core-js/modules/es6.math.tanh */ "./node_modules/core-js/modules/es6.math.tanh.js");

__webpack_require__(/*! core-js/modules/es6.math.trunc */ "./node_modules/core-js/modules/es6.math.trunc.js");

__webpack_require__(/*! core-js/modules/es6.number.constructor */ "./node_modules/core-js/modules/es6.number.constructor.js");

__webpack_require__(/*! core-js/modules/es6.number.epsilon */ "./node_modules/core-js/modules/es6.number.epsilon.js");

__webpack_require__(/*! core-js/modules/es6.number.is-finite */ "./node_modules/core-js/modules/es6.number.is-finite.js");

__webpack_require__(/*! core-js/modules/es6.number.is-integer */ "./node_modules/core-js/modules/es6.number.is-integer.js");

__webpack_require__(/*! core-js/modules/es6.number.is-nan */ "./node_modules/core-js/modules/es6.number.is-nan.js");

__webpack_require__(/*! core-js/modules/es6.number.is-safe-integer */ "./node_modules/core-js/modules/es6.number.is-safe-integer.js");

__webpack_require__(/*! core-js/modules/es6.number.max-safe-integer */ "./node_modules/core-js/modules/es6.number.max-safe-integer.js");

__webpack_require__(/*! core-js/modules/es6.number.min-safe-integer */ "./node_modules/core-js/modules/es6.number.min-safe-integer.js");

__webpack_require__(/*! core-js/modules/es6.number.parse-float */ "./node_modules/core-js/modules/es6.number.parse-float.js");

__webpack_require__(/*! core-js/modules/es6.number.parse-int */ "./node_modules/core-js/modules/es6.number.parse-int.js");

__webpack_require__(/*! core-js/modules/es6.object.assign */ "./node_modules/core-js/modules/es6.object.assign.js");

__webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");

__webpack_require__(/*! core-js/modules/es7.object.define-getter */ "./node_modules/core-js/modules/es7.object.define-getter.js");

__webpack_require__(/*! core-js/modules/es7.object.define-setter */ "./node_modules/core-js/modules/es7.object.define-setter.js");

__webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");

__webpack_require__(/*! core-js/modules/es6.object.define-properties */ "./node_modules/core-js/modules/es6.object.define-properties.js");

__webpack_require__(/*! core-js/modules/es7.object.entries */ "./node_modules/core-js/modules/es7.object.entries.js");

__webpack_require__(/*! core-js/modules/es6.object.freeze */ "./node_modules/core-js/modules/es6.object.freeze.js");

__webpack_require__(/*! core-js/modules/es6.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js");

__webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");

__webpack_require__(/*! core-js/modules/es6.object.get-own-property-names */ "./node_modules/core-js/modules/es6.object.get-own-property-names.js");

__webpack_require__(/*! core-js/modules/es6.object.get-prototype-of */ "./node_modules/core-js/modules/es6.object.get-prototype-of.js");

__webpack_require__(/*! core-js/modules/es7.object.lookup-getter */ "./node_modules/core-js/modules/es7.object.lookup-getter.js");

__webpack_require__(/*! core-js/modules/es7.object.lookup-setter */ "./node_modules/core-js/modules/es7.object.lookup-setter.js");

__webpack_require__(/*! core-js/modules/es6.object.prevent-extensions */ "./node_modules/core-js/modules/es6.object.prevent-extensions.js");

__webpack_require__(/*! core-js/modules/es6.object.is */ "./node_modules/core-js/modules/es6.object.is.js");

__webpack_require__(/*! core-js/modules/es6.object.is-frozen */ "./node_modules/core-js/modules/es6.object.is-frozen.js");

__webpack_require__(/*! core-js/modules/es6.object.is-sealed */ "./node_modules/core-js/modules/es6.object.is-sealed.js");

__webpack_require__(/*! core-js/modules/es6.object.is-extensible */ "./node_modules/core-js/modules/es6.object.is-extensible.js");

__webpack_require__(/*! core-js/modules/es6.object.keys */ "./node_modules/core-js/modules/es6.object.keys.js");

__webpack_require__(/*! core-js/modules/es6.object.seal */ "./node_modules/core-js/modules/es6.object.seal.js");

__webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es7.object.values */ "./node_modules/core-js/modules/es7.object.values.js");

__webpack_require__(/*! core-js/modules/es6.promise */ "./node_modules/core-js/modules/es6.promise.js");

__webpack_require__(/*! core-js/modules/es7.promise.finally */ "./node_modules/core-js/modules/es7.promise.finally.js");

__webpack_require__(/*! core-js/modules/es6.reflect.apply */ "./node_modules/core-js/modules/es6.reflect.apply.js");

__webpack_require__(/*! core-js/modules/es6.reflect.construct */ "./node_modules/core-js/modules/es6.reflect.construct.js");

__webpack_require__(/*! core-js/modules/es6.reflect.define-property */ "./node_modules/core-js/modules/es6.reflect.define-property.js");

__webpack_require__(/*! core-js/modules/es6.reflect.delete-property */ "./node_modules/core-js/modules/es6.reflect.delete-property.js");

__webpack_require__(/*! core-js/modules/es6.reflect.get */ "./node_modules/core-js/modules/es6.reflect.get.js");

__webpack_require__(/*! core-js/modules/es6.reflect.get-own-property-descriptor */ "./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");

__webpack_require__(/*! core-js/modules/es6.reflect.get-prototype-of */ "./node_modules/core-js/modules/es6.reflect.get-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.reflect.has */ "./node_modules/core-js/modules/es6.reflect.has.js");

__webpack_require__(/*! core-js/modules/es6.reflect.is-extensible */ "./node_modules/core-js/modules/es6.reflect.is-extensible.js");

__webpack_require__(/*! core-js/modules/es6.reflect.own-keys */ "./node_modules/core-js/modules/es6.reflect.own-keys.js");

__webpack_require__(/*! core-js/modules/es6.reflect.prevent-extensions */ "./node_modules/core-js/modules/es6.reflect.prevent-extensions.js");

__webpack_require__(/*! core-js/modules/es6.reflect.set */ "./node_modules/core-js/modules/es6.reflect.set.js");

__webpack_require__(/*! core-js/modules/es6.reflect.set-prototype-of */ "./node_modules/core-js/modules/es6.reflect.set-prototype-of.js");

__webpack_require__(/*! core-js/modules/es6.regexp.constructor */ "./node_modules/core-js/modules/es6.regexp.constructor.js");

__webpack_require__(/*! core-js/modules/es6.regexp.flags */ "./node_modules/core-js/modules/es6.regexp.flags.js");

__webpack_require__(/*! core-js/modules/es6.regexp.match */ "./node_modules/core-js/modules/es6.regexp.match.js");

__webpack_require__(/*! core-js/modules/es6.regexp.replace */ "./node_modules/core-js/modules/es6.regexp.replace.js");

__webpack_require__(/*! core-js/modules/es6.regexp.split */ "./node_modules/core-js/modules/es6.regexp.split.js");

__webpack_require__(/*! core-js/modules/es6.regexp.search */ "./node_modules/core-js/modules/es6.regexp.search.js");

__webpack_require__(/*! core-js/modules/es6.regexp.to-string */ "./node_modules/core-js/modules/es6.regexp.to-string.js");

__webpack_require__(/*! core-js/modules/es6.set */ "./node_modules/core-js/modules/es6.set.js");

__webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");

__webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

__webpack_require__(/*! core-js/modules/es6.string.anchor */ "./node_modules/core-js/modules/es6.string.anchor.js");

__webpack_require__(/*! core-js/modules/es6.string.big */ "./node_modules/core-js/modules/es6.string.big.js");

__webpack_require__(/*! core-js/modules/es6.string.blink */ "./node_modules/core-js/modules/es6.string.blink.js");

__webpack_require__(/*! core-js/modules/es6.string.bold */ "./node_modules/core-js/modules/es6.string.bold.js");

__webpack_require__(/*! core-js/modules/es6.string.code-point-at */ "./node_modules/core-js/modules/es6.string.code-point-at.js");

__webpack_require__(/*! core-js/modules/es6.string.ends-with */ "./node_modules/core-js/modules/es6.string.ends-with.js");

__webpack_require__(/*! core-js/modules/es6.string.fixed */ "./node_modules/core-js/modules/es6.string.fixed.js");

__webpack_require__(/*! core-js/modules/es6.string.fontcolor */ "./node_modules/core-js/modules/es6.string.fontcolor.js");

__webpack_require__(/*! core-js/modules/es6.string.fontsize */ "./node_modules/core-js/modules/es6.string.fontsize.js");

__webpack_require__(/*! core-js/modules/es6.string.from-code-point */ "./node_modules/core-js/modules/es6.string.from-code-point.js");

__webpack_require__(/*! core-js/modules/es6.string.includes */ "./node_modules/core-js/modules/es6.string.includes.js");

__webpack_require__(/*! core-js/modules/es6.string.italics */ "./node_modules/core-js/modules/es6.string.italics.js");

__webpack_require__(/*! core-js/modules/es6.string.iterator */ "./node_modules/core-js/modules/es6.string.iterator.js");

__webpack_require__(/*! core-js/modules/es6.string.link */ "./node_modules/core-js/modules/es6.string.link.js");

__webpack_require__(/*! core-js/modules/es7.string.pad-start */ "./node_modules/core-js/modules/es7.string.pad-start.js");

__webpack_require__(/*! core-js/modules/es7.string.pad-end */ "./node_modules/core-js/modules/es7.string.pad-end.js");

__webpack_require__(/*! core-js/modules/es6.string.raw */ "./node_modules/core-js/modules/es6.string.raw.js");

__webpack_require__(/*! core-js/modules/es6.string.repeat */ "./node_modules/core-js/modules/es6.string.repeat.js");

__webpack_require__(/*! core-js/modules/es6.string.small */ "./node_modules/core-js/modules/es6.string.small.js");

__webpack_require__(/*! core-js/modules/es6.string.starts-with */ "./node_modules/core-js/modules/es6.string.starts-with.js");

__webpack_require__(/*! core-js/modules/es6.string.strike */ "./node_modules/core-js/modules/es6.string.strike.js");

__webpack_require__(/*! core-js/modules/es6.string.sub */ "./node_modules/core-js/modules/es6.string.sub.js");

__webpack_require__(/*! core-js/modules/es6.string.sup */ "./node_modules/core-js/modules/es6.string.sup.js");

__webpack_require__(/*! core-js/modules/es6.string.trim */ "./node_modules/core-js/modules/es6.string.trim.js");

__webpack_require__(/*! core-js/modules/es6.typed.array-buffer */ "./node_modules/core-js/modules/es6.typed.array-buffer.js");

__webpack_require__(/*! core-js/modules/es6.typed.data-view */ "./node_modules/core-js/modules/es6.typed.data-view.js");

__webpack_require__(/*! core-js/modules/es6.typed.int8-array */ "./node_modules/core-js/modules/es6.typed.int8-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.uint8-array */ "./node_modules/core-js/modules/es6.typed.uint8-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.uint8-clamped-array */ "./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.int16-array */ "./node_modules/core-js/modules/es6.typed.int16-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.uint16-array */ "./node_modules/core-js/modules/es6.typed.uint16-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.int32-array */ "./node_modules/core-js/modules/es6.typed.int32-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.uint32-array */ "./node_modules/core-js/modules/es6.typed.uint32-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.float32-array */ "./node_modules/core-js/modules/es6.typed.float32-array.js");

__webpack_require__(/*! core-js/modules/es6.typed.float64-array */ "./node_modules/core-js/modules/es6.typed.float64-array.js");

__webpack_require__(/*! core-js/modules/es6.weak-map */ "./node_modules/core-js/modules/es6.weak-map.js");

__webpack_require__(/*! core-js/modules/es6.weak-set */ "./node_modules/core-js/modules/es6.weak-set.js");

__webpack_require__(/*! core-js/modules/web.timers */ "./node_modules/core-js/modules/web.timers.js");

__webpack_require__(/*! core-js/modules/web.immediate */ "./node_modules/core-js/modules/web.immediate.js");

__webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");

__webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");

__webpack_require__(/*! whatwg-fetch */ "./node_modules/whatwg-fetch/fetch.js");

__webpack_require__(/*! ~/styles/main.scss */ "./src/styles/main.scss");

__webpack_require__(/*! ~/scripts/lib/autotrack */ "./src/scripts/lib/autotrack.js");

var _react = _interopRequireDefault(__webpack_require__(/*! react */ "./node_modules/react/index.js"));

var _reactDom = __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js");

var _App = _interopRequireDefault(__webpack_require__(/*! ~/scripts/components/App */ "./src/scripts/components/App.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactDom.render)(_react.default.createElement(_App.default, null), document.getElementById("root"));

/***/ }),

/***/ "./src/scripts/utils/ease.js":
/*!***********************************!*\
  !*** ./src/scripts/utils/ease.js ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linear = linear;
exports.easeInSine = easeInSine;
exports.easeOutSine = easeOutSine;
exports.easeInOutSine = easeInOutSine;
exports.easeInQuad = easeInQuad;
exports.easeOutQuad = easeOutQuad;
exports.easeInOutQuad = easeInOutQuad;
exports.easeInCubic = easeInCubic;
exports.easeOutCubic = easeOutCubic;
exports.easeInOutCubic = easeInOutCubic;
exports.easeInQuart = easeInQuart;
exports.easeOutQuart = easeOutQuart;
exports.easeInOutQuart = easeInOutQuart;
exports.easeInQuint = easeInQuint;
exports.easeOutQuint = easeOutQuint;
exports.easeInOutQuint = easeInOutQuint;
exports.easeInExpo = easeInExpo;
exports.easeOutExpo = easeOutExpo;
exports.easeInOutExpo = easeInOutExpo;
exports.easeInCirc = easeInCirc;
exports.easeOutCirc = easeOutCirc;
exports.easeInOutCirc = easeInOutCirc;
exports.easeInBack = easeInBack;
exports.easeOutBack = easeOutBack;
exports.easeInOutBack = easeInOutBack;
exports.easeInElastic = easeInElastic;
exports.easeOutElastic = easeOutElastic;
exports.easeInOutElastic = easeInOutElastic;
exports.easeOutBounce = easeOutBounce;
exports.easeInBounce = easeInBounce;
exports.easeInOutBounce = easeInOutBounce;

// Based on https://gist.github.com/gre/1650294
// No easing, no acceleration
function linear(t) {
  return t;
} // Slight acceleration from zero to full speed


function easeInSine(t) {
  return -1 * Math.cos(t * (Math.PI / 2)) + 1;
} // Slight deceleration at the end


function easeOutSine(t) {
  return Math.sin(t * (Math.PI / 2));
} // Slight acceleration at beginning and slight deceleration at end


function easeInOutSine(t) {
  return -0.5 * (Math.cos(Math.PI * t) - 1);
} // Accelerating from zero velocity


function easeInQuad(t) {
  return t * t;
} // Decelerating to zero velocity


function easeOutQuad(t) {
  return t * (2 - t);
} // Acceleration until halfway, then deceleration


function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
} // Accelerating from zero velocity


function easeInCubic(t) {
  return t * t * t;
} // Decelerating to zero velocity


function easeOutCubic(t) {
  var t1 = t - 1;
  return t1 * t1 * t1 + 1;
} // Acceleration until halfway, then deceleration


function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
} // Accelerating from zero velocity


function easeInQuart(t) {
  return t * t * t * t;
} // Decelerating to zero velocity


function easeOutQuart(t) {
  var t1 = t - 1;
  return 1 - t1 * t1 * t1 * t1;
} // Acceleration until halfway, then deceleration


function easeInOutQuart(t) {
  var t1 = t - 1;
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * t1 * t1 * t1 * t1;
} // Accelerating from zero velocity


function easeInQuint(t) {
  return t * t * t * t * t;
} // Decelerating to zero velocity


function easeOutQuint(t) {
  var t1 = t - 1;
  return 1 + t1 * t1 * t1 * t1 * t1;
} // Acceleration until halfway, then deceleration


function easeInOutQuint(t) {
  var t1 = t - 1;
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * t1 * t1 * t1 * t1 * t1;
} // Accelerate exponentially until finish


function easeInExpo(t) {
  if (t === 0) {
    return 0;
  }

  return Math.pow(2, 10 * (t - 1));
} // Initial exponential acceleration slowing to stop


function easeOutExpo(t) {
  if (t === 1) {
    return 1;
  }

  return -Math.pow(2, -10 * t) + 1;
} // Exponential acceleration and deceleration


function easeInOutExpo(t) {
  if (t === 0 || t === 1) {
    return t;
  }

  var scaledTime = t * 2;
  var scaledTime1 = scaledTime - 1;

  if (scaledTime < 1) {
    return 0.5 * Math.pow(2, 10 * scaledTime1);
  }

  return 0.5 * (-Math.pow(2, -10 * scaledTime1) + 2);
} // Increasing velocity until stop


function easeInCirc(t) {
  var scaledTime = t / 1;
  return -1 * (Math.sqrt(1 - scaledTime * t) - 1);
} // Start fast, decreasing velocity until stop


function easeOutCirc(t) {
  var t1 = t - 1;
  return Math.sqrt(1 - t1 * t1);
} // Fast increase in velocity, fast decrease in velocity


function easeInOutCirc(t) {
  var scaledTime = t * 2;
  var scaledTime1 = scaledTime - 2;

  if (scaledTime < 1) {
    return -0.5 * (Math.sqrt(1 - scaledTime * scaledTime) - 1);
  }

  return 0.5 * (Math.sqrt(1 - scaledTime1 * scaledTime1) + 1);
} // Slow movement backwards then fast snap to finish


function easeInBack(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.70158;
  return t * t * ((magnitude + 1) * t - magnitude);
} // Fast snap to backwards point then slow resolve to finish


function easeOutBack(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.70158;
  var scaledTime = t / 1 - 1;
  return scaledTime * scaledTime * ((magnitude + 1) * scaledTime + magnitude) + 1;
} // Slow movement backwards, fast snap to past finish, slow resolve to finish


function easeInOutBack(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.70158;
  var scaledTime = t * 2;
  var scaledTime2 = scaledTime - 2;
  var s = magnitude * 1.525;

  if (scaledTime < 1) {
    return 0.5 * scaledTime * scaledTime * ((s + 1) * scaledTime - s);
  }

  return 0.5 * (scaledTime2 * scaledTime2 * ((s + 1) * scaledTime2 + s) + 2);
} // Bounces slowly then quickly to finish


function easeInElastic(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.7;

  if (t === 0 || t === 1) {
    return t;
  }

  var scaledTime = t / 1;
  var scaledTime1 = scaledTime - 1;
  var p = 1 - magnitude;
  var s = p / (2 * Math.PI) * Math.asin(1);
  return -(Math.pow(2, 10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p));
} // Fast acceleration, bounces to zero


function easeOutElastic(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.7;
  var p = 1 - magnitude;
  var scaledTime = t * 2;

  if (t === 0 || t === 1) {
    return t;
  }

  var s = p / (2 * Math.PI) * Math.asin(1);
  return Math.pow(2, -10 * scaledTime) * Math.sin((scaledTime - s) * (2 * Math.PI) / p) + 1;
} // Slow start and end, two bounces sandwich a fast motion


function easeInOutElastic(t) {
  var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.65;
  var p = 1 - magnitude;

  if (t === 0 || t === 1) {
    return t;
  }

  var scaledTime = t * 2;
  var scaledTime1 = scaledTime - 1;
  var s = p / (2 * Math.PI) * Math.asin(1);

  if (scaledTime < 1) {
    return -0.5 * (Math.pow(2, 10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p));
  }

  return Math.pow(2, -10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
} // Bounce to completion


function easeOutBounce(t) {
  var scaledTime = t / 1;

  if (scaledTime < 1 / 2.75) {
    return 7.5625 * scaledTime * scaledTime;
  } else if (scaledTime < 2 / 2.75) {
    var scaledTime2 = scaledTime - 1.5 / 2.75;
    return 7.5625 * scaledTime2 * scaledTime2 + 0.75;
  } else if (scaledTime < 2.5 / 2.75) {
    var _scaledTime = scaledTime - 2.25 / 2.75;

    return 7.5625 * _scaledTime * _scaledTime + 0.9375;
  } else {
    var _scaledTime2 = scaledTime - 2.625 / 2.75;

    return 7.5625 * _scaledTime2 * _scaledTime2 + 0.984375;
  }
} // Bounce increasing in velocity until completion


function easeInBounce(t) {
  return 1 - easeOutBounce(1 - t);
} // Bounce in and bounce out


function easeInOutBounce(t) {
  if (t < 0.5) {
    return easeInBounce(t * 2) * 0.5;
  }

  return easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
}

/***/ }),

/***/ "./src/scripts/utils/is-mobile.js":
/*!****************************************!*\
  !*** ./src/scripts/utils/is-mobile.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkMobile = checkMobile;
exports.isMobile = void 0;

function checkMobile() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var MOBILE_WINDOW = /windows phone/i.test(userAgent);
  var MOBILE_ANDROID = /android/i.test(userAgent);
  var MOBILE_IOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  return MOBILE_IOS || MOBILE_ANDROID || MOBILE_WINDOW;
}

var isMobile = checkMobile();
exports.isMobile = isMobile;

/***/ }),

/***/ "./src/scripts/utils/w.js":
/*!********************************!*\
  !*** ./src/scripts/utils/w.js ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.w = w;
exports.W = void 0;

var _lodash = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var inst = null;

function w() {
  if (!inst) inst = new W();
  return inst;
}

var W =
/*#__PURE__*/
function () {
  _createClass(W, null, [{
    key: "instance",
    value: function instance() {
      if (this._instance) return this._instance;
      return this._instance = new this();
    }
  }]);

  function W() {
    var _this = this;

    _classCallCheck(this, W);

    _defineProperty(this, "h", void 0);

    _defineProperty(this, "w", void 0);

    _defineProperty(this, "tick", function () {
      _this.h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      _this.w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    });

    this.tick(); // this.tick = debounce(this.tick, 250);

    window.addEventListener("resize", this.tick);
  }

  return W;
}();

exports.W = W;

/***/ }),

/***/ "./src/styles/main.scss":
/*!******************************!*\
  !*** ./src/styles/main.scss ***!
  \******************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/*!***********************************!*\
  !*** multi ./src/scripts/main.js ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./src/scripts/main.js */"./src/scripts/main.js");


/***/ }),

/***/ 1:
/*!*********************************!*\
  !*** readable-stream (ignored) ***!
  \*********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.132514f2.js